<template>
  <b-modal :id="id" modal-class="modal-type-setting d-flex align-items-center" body-class="px-0" size="xl" :no-close-on-esc="true" hide-footer hide-header centered :no-close-on-backdrop="isClose" @hide="closeModal">
    <div class="buttonClose d-flex">
      <b-button
        size="sm"
        class="btn-close d-flex flex-row align-items-center"
        variant="link"
        @click="closeModal"
      >
        <i class="material-icons material-icons-outlined">close</i>
      </b-button>
    </div>
    <div class="modal-wrap-colum d-flex">
      <!-- left -->
      <div class="modal-left">
        <!-- top -->
        <div class="modal-left__top">
          <h4 class="titleHeader">{{titleHeaderModal}}</h4>
          <img src="../../assets/images/type-setting/task_type_setting.svg">
          <div class="switch-btn-wrapper switch-btn-wrapper__enable-task-type" v-if="taskTypeSettingForm['isDisplayButton']">
            <switch-button
              v-model="taskTypeSettingForm['isEnabled']"
              id="radio-enable-task-type"
              activeLabel="無効"
              inactiveLabel="有効"
              :checked="taskTypeSettingForm['isEnabled']"
              :disabled="!hasUseCaseOnWorkInstruction(taskTypeSettingForm['workInstruction'])"
            />
          </div>
        </div>
        <!-- bot -->
        <div class="modal-left__bot">
          <!-- step -->
          <div class="modal-left__step">
            <!-- item -->
            <div class="item" :class="{selected: step === 1, completed: stepLists.includes(1)}">
              <div class="d-flex align-items-center text">
                <div class="num">1.</div>
                <div class="label">識別情報</div>
              </div>
              <div class="check"><i class="material-icons">done</i></div>
            </div>
            <!-- item -->
            <div class="item" :class="{selected: step === 2, completed: stepLists.includes(2)}">
              <div class="d-flex align-items-center text">
                <div class="num">2.</div>
                <div class="label">仕分けルール</div>
              </div>
              <div class="check"><i class="material-icons">done</i></div>
            </div>
            <!-- item -->
            <div class="item" :class="{selected: step === 3, completed: stepLists.includes(3)}">
              <div class="d-flex align-items-center text">
                <div class="num">3.</div>
                <div class="label">投入・スキャン</div>
              </div>
              <div class="check"><i class="material-icons">done</i></div>
            </div>
            <!-- item -->
            <!-- <div class="item" :class="{selected: step === 4, completed: stepLists.includes(4)}">
              <div class="d-flex align-items-center text">
                <div class="num">4.</div>
                <div class="label">箱回収</div>
              </div>
              <div class="check"><i class="material-icons">done</i></div>
            </div> -->
          </div>
          <div class="modal-left__btn-save">
            <b-button hidden class="btn-close" @click="closeModal">閉じる</b-button>
            <b-button type="button" class="btn-info border-info" @click="handleDoSave" :disabled="!enableSubmit">保存</b-button>
          </div>
        </div>
      </div>
      <!-- right -->
      <div class="modal-right" id="modal-right">
        <AlertMessageComponent class="mb-2"/>
        <validation-observer  ref="formSubmit" class="w-100">
          <b-form class="submit-form" @keydown.enter.prevent>
            <!-- step 1 -->
            <div v-if="step === 1" class="step-1">
              <!-- title -->
              <div class="modal-right__title">
                  <h4>識別情報</h4>
                  <tooltip-component
                    :title="`業務ごとの仕分け判別用の番号と命名を行ってください。（例：1.繁忙期用仕分け、2.常用仕分け、3.◯◯専用仕分け...など）<br>
                    メモは利用シーンや、引き継ぎ情報などを入力ください。`"
                  />
              </div>
              <div class="modal-right__form">
                <!-- form group -->
                <div class="form-group">
                  <div class="form-group__label">
                    <span>番号</span><span class="required">必須</span>
                  </div>
                  <div class="form-group__control">
                    <ValidationProvider
                      mode="passive"
                      name="番号"
                      class="mb-2"
                      :rules="`required|customExcluded:${taskTypeList}`"
                      v-slot="{ errors }"
                    >
                      <input-number-component
                        class="w-100"
                        :maxValue="maxTaskType"
                        :minValue="minTaskType"
                        :id="'taskTypeField'"
                        @blur="cleanValidity('taskTypeField')"
                        v-model.number="taskTypeSettingForm['taskType']"
                        :state="errors && errors.length ? true : false"
                        :class="[
                          errors [0]? 'border-danger bg-danger-outline' : ''
                        ]"
                      />
                      <!-- Handle Error Message -->
                      <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                        {{ errors[i] }}
                      </small>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- form group -->
                <div class="form-group">
                  <div class="form-group__label">
                    <span>名前</span><span class="required">必須</span>
                  </div>
                  <div class="form-group__control">
                    <ValidationProvider
                      mode="passive"
                      name="名前"
                      class="mb-2"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <input-text-component
                        class="w-100"
                        id="taskTypeNameField"
                        :maxlength="32"
                        v-model="taskTypeSettingForm['taskTypeName']"
                        :state="errors && errors.length ? true : false"
                        @blur="cleanValidity('taskTypeNameField')"
                        @onInput="preventInvalidInputValue(...arguments, 'taskTypeNameField')"
                      />
                      <!-- Handle Error Message -->
                      <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                        {{ errors[i] }}
                      </small>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- form group -->
                <div class="form-group">
                  <div class="form-group__label">
                    <span>メモ</span>
                  </div>
                  <div class="form-group__control">
                    <ValidationProvider
                      mode="passive"
                      name="メモ"
                      class="mb-2"
                      v-slot="{ errors }"
                    >
                      <input-text-component
                        class="w-100"
                        id="taskTypeMemoField"
                        :maxlength="20"
                        @blur="cleanValidity('taskTypeMemoField')"
                        v-model="taskTypeSettingForm['memo']"
                        :state="errors && errors.length ? true : false"
                      />
                      <!-- Handle Error Message -->
                      <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                        {{ errors[i] }}
                      </small>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
            <!-- step 2 -->
            <div v-else-if="step === 2" class="step-2">
              <!-- if modal type is clone data, it will hide work instruction field -->
              <!-- title -->
              <div class="modal-right__title">
                  <h4>仕分け方法</h4>
                  <tooltip-component
                    :title="taskTypeSettingTooltipMap.get('workInstruction')"
                  />
                  <span class="required">必須</span>
              </div>
              <!-- if modal type is clone data, it will hide work instruction field -->
              <!-- radio -->
              <div class="radio-custom">
                <!-- item -->
                <label
                  v-if="hasOrderSortUseCase"
                  :class="[{
                    'disabled': isCloneModalType()
                  }, 'radio-custom__item']"
                >
                  <input
                  type="radio"
                  name="workInstruction"
                  @change="onChangeRadioButton($event, 'workInstruction')"
                  :value="1"
                  :checked="taskTypeSettingForm['workInstruction'] === 1"
                  v-model="taskTypeSettingForm['workInstruction']"
                  :disabled="isCloneModalType()"
                  >
                  <span class="radio-custom__checkmark"></span>
                  <div class="radio-custom__overlay"></div>
                  <div class="radio-custom__img">
                    <img src="../../assets/images/type-setting/order_sorting.svg">
                  </div>
                  <div class="radio-custom__body">
                    <div class="radio-custom__title">オーダー仕分け（作業指示あり）</div>
                    <div class="radio-custom__content work-instruction-content">
                      オーダー単位でシュートに商品を仕分け投入します。<br>
                      作業指示データを基に仕分けを行います。<br>
                      日々作業指示データを基に仕分けを行いたい時にご利用ください。
                      <div class="radio-custom__note">オーダー別仕分け / 店舗別出荷仕分け 等にオススメ</div>
                    </div>
                  </div>
                </label>
                <!-- item -->
                <label
                  v-if="hasNoTaskSortUseCase"
                  :class="[{
                      'disabled': isCloneModalType()
                  }, 'radio-custom__item']"
                >
                  <input
                  type="radio"
                  name="workInstruction"
                  @change="onChangeRadioButton($event, 'workInstruction')"
                  :value="0"
                  :checked="taskTypeSettingForm['workInstruction'] === 0"
                  v-model="taskTypeSettingForm['workInstruction']"
                  :disabled="isCloneModalType()"
                  >
                  <span class="radio-custom__checkmark"></span>
                  <div class="radio-custom__overlay"></div>
                  <div class="radio-custom__img">
                    <img src="../../assets/images/type-setting/shoot_sorting.svg">
                  </div>
                  <div class="radio-custom__body">
                    <div class="radio-custom__title">方面別仕分け（作業指示なし）</div>
                    <div class="radio-custom__content work-instruction-content">
                      スキャンコードとシュートの組み合わせで商品を仕分け投入します。<br>
                      仕分けマスタの情報を基に仕分けを行います。<br>
                      決まったコードに対しての仕分けを行いたい時にご利用ください。
                    <div class="radio-custom__note">EC出荷方面別仕分け / TC倉庫方面別仕分け 等にオススメ</div>
                    </div>
                  </div>
                </label>
              </div>
              <div v-if="taskTypeSettingForm['workInstruction'] === 1">
                <div class="assign-chute-manual">
                  <!-- title -->
                  <div class="modal-right__title">
                    <h4>投下シュートの指定方法</h4>
                    <tooltip-component
                      :title="`方面別にシュートを指定する等、投下するシュートを詳細に指定する場合は「作業指示データに含む」を選択してください。`"
                    />
                    <span class="required">必須</span>
                  </div>
                  <!-- radio -->
                  <div class="radio-custom">
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="assignChuteNoManual"
                      :value="1"
                      :checked="taskTypeSettingForm['assignChuteNoManual'] === 1"
                      v-model="taskTypeSettingForm['assignChuteNoManual']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/upload_csv.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">作業指示データに含む</div>
                        <div class="radio-custom__content">
                          作業指示データで投下するシュートを指定します。
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="assignChuteNoManual"
                      :value="0"
                      :checked="taskTypeSettingForm['assignChuteNoManual'] === 0"
                      v-model="taskTypeSettingForm['assignChuteNoManual']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/list.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">+Hub BASEで自動割当</div>
                        <div class="radio-custom__content">
                          ルールを作成して投下するシュートを自動割当します。
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div class="chute-rule">
                  <!-- title -->
                  <div class="modal-right__title">
                    <h4>シュートのルール</h4>
                    <span class="required">必須</span>
                  </div>
                  <div class="box-rule">
                    <!-- form group -->
                    <div class="form-group pl-0 mb-0">
                      <div class="form-group__label">
                        <span>連続投入回数</span>
                        <tooltip-component
                          :title="`同じシュートへ連続投下する数を設定できます。<br>
                          1〜999 の範囲で設定可能です。`"
                        />
                      </div>
                      <div class="form-group__control">
                        <ValidationProvider
                          mode="passive"
                          name="連続投入回数"
                          class="mb-2"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <input-number-component
                            class="w-30"
                            id="continuousEntryTimes"
                            :maxValue="maxContinuousEntryTimes"
                            :minValue="minContinuousEntryTimes"
                            @blur="cleanValidity('continuousEntryTimes')"
                            v-model.number="taskTypeSettingForm['continuousEntryTimes']"
                            :state="errors && errors.length ? true : false"
                          />
                          <!-- Handle Error Message -->
                          <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                            {{ errors[i] }}
                          </small>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="taskTypeSettingForm['workInstruction'] === 1 && taskTypeSettingForm['assignChuteNoManual'] === 0">
                <!-- title -->
                <div class="modal-right__title pt-5">
                  <h4>シュート自動割当のルール</h4>
                  <tooltip-component
                    :title="`連携するシステムがない場合または連携システムから投下シュートを指定しない場合の設定です。`"
                  />
                  <span class="required">必須</span>
                </div>
                <!-- box rule -->
                <div class="box-rule d-flex">
                  <div class="box-rule__left">
                    <img src="../../assets/images/type-setting/rule_sorting.svg">
                  </div>
                  <div class="box-rule__right w-100">
                    <!-- form group -->
                    <div class="form-group pl-0">
                      <div class="form-group__label">
                        <span>{{sortingSetting.htmlLabel}}</span>
                        <tooltip-component
                          :title="sortingSetting.helpComment"
                        />
                      </div>
                      <div v-for="(value, indx) in sortingSettingList" :key="indx" class="form-group__select-list d-flex align-items-center">
                        <div class="no">{{ indx+1 }}</div>
                        <div class="form-group__control">
                          <ValidationProvider
                            mode="passive"
                            name="割当キー"
                            class="mb-2"
                            v-slot="{ errors }"
                          >
                            <form-select-component
                              :id="`sortingSetting_${indx}`"
                              class="sortingSettingSelected"
                              :options="sortingSetting.items.map(item => item.itemValue)"
                              :customLabel="opt => sortingSetting.items.find(item => item.itemValue === opt).itemLabel"
                              v-model="sortingSettingSelected[indx]"
                              :state="!errors.length ? null : false"
                              :openDirection="'top'"
                            />
                            <!-- Handle Error Message -->
                            <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                              {{ errors[i] }}
                            </small>
                          </ValidationProvider>
                        </div>
                        <div class="box-rule__remove ml-2">
                          <button v-if="sortingSettingList.length !== 1" @click.prevent="removeSortingSetting(indx)"><i class="material-icons">delete</i></button>
                        </div>
                      </div>
                      <b-button v-if="sortingSettingList.length !== 5" class="btn box-rule__add" @click.prevent="addSortingSetting">
                        <span data-v-2a457fd7="" class="material-icons material-icons-outlined">add</span>
                        追加
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- step 3 -->
            <div v-else-if="step === 3" class="step-3">
              <!-- title -->
              <div class="modal-right__title">
                  <h4>商品の投入方法（複数可）</h4>
                  <tooltip-component
                    :title="taskTypeSettingTooltipMap.get('workType')"
                  />
                  <span class="required ml-2">必須</span>
              </div>
              <div class="wrap-box-border">
                <!-- checkbox -->
                <div class="checkbox-custom">
                  <!-- item -->
                  <label class="checkbox-custom__item" :class="{active: isActiveCheckbox('workType', 1)}">
                    <input
                    type="checkbox"
                    :value="1"
                    v-model="taskTypeSettingForm['workType']"
                    @change="onChangeCheckBox($event, 1)"
                    >
                    <span class="checkbox-custom__checkmark"></span>
                    <div class="checkbox-custom__overlay"></div>
                    <div class="checkbox-custom__body">
                      <div class="checkbox-custom__title">単一投入</div>
                      <div class="checkbox-custom__content">
                        <img src="../../assets/images/type-setting/product_method_1.svg">
                      </div>
                    </div>
                  </label>
                  <!-- item -->
                  <label id="multi-sorting" :class="['checkbox-custom__item', {active: isActiveCheckbox('workType', 3), 'disabled-work-type': !enableMultiSortSetting}]">
                    <input
                    type="checkbox"
                    :value="3"
                    v-model="taskTypeSettingForm['workType']"
                    @change="onChangeCheckBox($event, 3)"
                    :disabled="!enableMultiSortSetting"
                    >
                    <span :class="['checkbox-custom__checkmark', {'disabled': !enableMultiSortSetting}]"></span>
                    <div :class="['checkbox-custom__overlay', {'disabled': !enableMultiSortSetting}]"></div>
                    <div class="checkbox-custom__body">
                      <div class="checkbox-custom__title">まとめ投入</div>
                      <div class="checkbox-custom__content">
                        <img src="../../assets/images/type-setting/product_method_2.svg">
                      </div>
                    </div>
                  </label>
                  <b-tooltip v-if="!enableMultiSortSetting" target="multi-sorting" title="ご利用のプランでは使用できません" variant="secondary" />
                  <!-- item -->
                  <label class="checkbox-custom__item" :class="{active: isActiveCheckbox('workType', 2)}" :hidden="!taskTypeSettingForm['workInstruction'] || !showManualSortSetting">
                    <input
                    type="checkbox"
                    :value="2"
                    v-model="taskTypeSettingForm['workType']"
                    @change="onChangeCheckBox($event, 2)"
                    >
                    <span class="checkbox-custom__checkmark"></span>
                    <div class="checkbox-custom__overlay"></div>
                    <div class="checkbox-custom__body">
                      <div class="checkbox-custom__title">手仕分け</div>
                      <div class="checkbox-custom__content">
                        <img src="../../assets/images/type-setting/product_method_3.svg">
                      </div>
                    </div>
                  </label>
                </div>
                <div v-if="isActiveCheckbox('workType', 1)">
                  <!-- title -->
                  <div class="modal-right__title d-flex justify-content-between align-items-center mb-0">
                    <div class="d-flex align-items-center mb-4">
                        <h4>エラー時の対応</h4>
                         <tooltip-component
                          :title="taskTypeSettingTooltipMap.get('rejectSetting')"
                        />
                        <span class="required">必須</span>
                    </div>
                  </div>
                  <!-- radio -->
                  <div class="radio-custom radio-custom--xl">
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectSetting"
                      :value="0"
                      v-model="taskTypeSettingForm['rejectSetting']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/error_case_2.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">エラー表示して仕分けをストップ</div>
                        <div class="radio-custom__content">
                          作業員の手を止めて、都度処理します。
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectSetting"
                      :value="1"
                      v-model="taskTypeSettingForm['rejectSetting']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/error_case_1.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">指定のシュートへリジェクト</div>
                        <div class="radio-custom__content">
                          作業員の手を止めることなく指定のシュート <br>
                          No「{{pRejectChuteNo}}」に投下、後でまとめて処理します。
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div v-if="taskTypeSettingForm['rejectSetting'] === 1 && isActiveCheckbox('workType', 1)">
                  <!-- title -->
                  <div class="modal-right__title d-flex justify-content-between align-items-center mb-0">
                    <div class="d-flex align-items-center mb-4">
                      <h4>リジェクトデータの取扱い</h4>
                      <tooltip-component
                        :title="taskTypeSettingTooltipMap.get('rejectCreateNewTaskFlag')"
                      />
                      <span class="required">必須</span>
                    </div>
                  </div>
                  <!-- radio -->
                  <div class="radio-custom">
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectCreateNewTaskFlag"
                      :value="1"
                      v-model="taskTypeSettingForm['rejectCreateNewTaskFlag']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/reject_1.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">記録する</div>
                        <div class="radio-custom__content">
                          実績データ（タスク明細）に記録します。
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectCreateNewTaskFlag"
                      :value="0"
                      v-model="taskTypeSettingForm['rejectCreateNewTaskFlag']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/reject_2.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">残さない</div>
                      </div>
                    </label>
                  </div>
                </div>
                <div v-if="taskTypeSettingForm['rejectSetting'] === 1 && taskTypeSettingForm['workInstruction'] === 1 && isActiveCheckbox('workType', 1)">
                  <!-- title -->
                  <div class="modal-right__title d-flex justify-content-between align-items-center mb-0">
                    <div class="d-flex align-items-center mb-4">
                      <h4>予定個数よりも多くスキャンした時の対応</h4>
                      <tooltip-component class="error_flag_tooltip"
                        :title="taskTypeSettingTooltipMap.get('rejectShowErrorFlag')"
                      />
                      <span class="required">必須</span>
                    </div>
                  </div>
                  <!-- radio -->
                  <div class="radio-custom radio-custom--xl">
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectShowErrorFlag"
                      :value="1"
                      v-model="taskTypeSettingForm['rejectShowErrorFlag']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/plan_1.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">エラー表示して仕分けをストップ</div>
                        <div class="radio-custom__content">
                          作業員の手を止めて、都度処理します。
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="rejectShowErrorFlag"
                      :value="0"
                      v-model="taskTypeSettingForm['rejectShowErrorFlag']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__img">
                        <img src="../../assets/images/type-setting/plan_2.svg">
                      </div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title">指定のシュートへリジェクト</div>
                        <div class="radio-custom__content">
                          作業員の手を止めることなく指定のシュート<br>
                          No「{{pRejectChuteNo}}」に投下、後でまとめて処理します。
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <!-- title -->
                <div class="modal-right__title d-flex justify-content-between align-items-center mb-0">
                  <div class="d-flex align-items-center mb-4">
                      <h4>スキャン項目</h4>
                      <tooltip-component
                        :title="'スキャン画面に表示する項目の設定です。選択している「商品の投入方法」ごとに設定できます。<br>表示名や並び順を変更することもできます。'"
                      />
                  </div>
                </div>
                <!-- SCAN ITEMS - START -->
                <div class="scanItems">
                  <div class="scanItems__form">
                    <!-- BUILD TABS MENU TO WORK TYPE - START -->
                    <div class="scanItems__form__tabs">
                      <b-col class="col-12 px-0 d-flex tabsMenu">
                        <ul class="nav nav-pills" v-if="tabsMenu">
                          <li class="nav-item" v-for="(key, idx) in tabsMenu" :key="idx">
                            <a
                              :class="[{ isActiveTab: key['value'] === tabActive }, 'nav-link', 'itemMenu']"
                              @click="onChangeTabMenu(key['value'])"
                            >
                              {{ key['label'] }}
                            </a>
                          </li>
                        </ul>
                      </b-col>
                    </div>
                    <!-- BUILD TABS MENU TO WORK TYPE - END -->
                    <div class="underLineTabs"></div>
                    <div class="scanItems__form__blockList">
                      <!-- <span class="description" v-html="titleTableScanItem"></span> -->
                      <div class="d-flex flex-column scanItems__form__blockList__tableAdImage">
                        <!-- BUILD TABLE ACCORDING TO WORK TYPE - START -->
                        <div class="wrap-table">
                          <table class="table table-sm">
                            <thead>
                              <tr>
                                <th style="width: 2%"></th>
                                <th style="width: 10%">表示順</th>
                                <th style="width: 68%">表示名</th>
                                <th style="width: 20%"></th>
                              </tr>
                            </thead>
                            <draggable
                              tag="tbody"
                              :list="scanItemsTable[tabActive]"
                              draggable=".data_flow"
                              :move="onMoveColumnOrder"
                              @end="onEndColumnOrder"
                              filter=".noAcceptDrag"
                              :preventOnFilter="false"
                            >
                              <tr
                                class="data_flow"
                                v-for="(data, index) in scanItemsTable[tabActive]"
                                :key="index"
                                @mouseover="displayEditAdDragIcon(index, true)"
                                @mouseout="displayEditAdDragIcon(index, false)"
                              >
                                <template v-if="data.isVisible === 1">
                                  <td>
                                    <div class="d-flex align-items-center justify-content-center">
                                      <span
                                        :id="`dragIcon_${index}`"
                                        class="icon_drag material-icons material-icons-outlined"
                                      >
                                        drag_indicator
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    {{ data.order }}
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <editable-label
                                        :text="editMode
                                          ? scanItemsRequest[data.workType][`${data.items[0].fieldId}Name`]
                                          : formatedLabelName(
                                            scanItemsRequest[data.workType][`${data.items[0].fieldId}Name`],
                                            data.workType, data.items[0].fieldId)"
                                        :maxlength="50"
                                        :id="'txt_header' + index"
                                        :ref="`editLabel_${index}_${data.workType}`"
                                        v-on:edit-mode="value => editMode = value"
                                        v-on:text-updated="onEditItemName(...arguments, data)"
                                        class="editable-input"
                                      />
                                      <span
                                        class="material-icons material-icons-outlined edit_icon_detail mr-1"
                                        :id="`editIcon_${index}`"
                                        @click="switchToEditMode(index, data.workType)"
                                      >
                                        edit
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="switch-wrapper switch-wrapper--like-checkbox">
                                      <div class="switch">
                                        <input
                                        v-for="(item, indx) in data.items" :key="indx"
                                        type="radio"
                                        class="switch-radio"
                                        :class="[indx === 0 ? 'left' : 'right', ]"
                                        :value="item.itemValue"
                                        :id="`${item.itemValue}_${item.fieldId}`"
                                        :disabled="item.itemIsVisible !== 1"
                                        v-model="scanItemsRequest[data.workType][item.fieldId]"
                                        />
                                        <div class="slider" :class="{ 'disabled': data.items.some(item => item.itemIsVisible !== 1) }">
                                          <label
                                          v-for="(item, indx) in data.items"
                                          :key="indx"
                                          class="switch-radio-label"
                                          :class="[indx === 0 ? 'left active' : 'right inactive', ]"
                                          :for="`${item.itemValue}_${item.fieldId}`">
                                          </label>
                                        </div>
                                        <div class="label-text">表示</div>
                                      </div>
                                    </div>
                                  </td>
                                </template>
                              </tr>
                            </draggable>
                          </table>
                        </div>
                        <!-- BUILD TABLE ACCORDING TO WORK TYPE - END -->
                        <div class="blockPreview">
                          <span class="blockPreview__title">&lt;表示例&gt;</span>
                          <div class="blockPreview__wrap-preview">
                            <div class="blockPreview__image">
                              <img src="../../assets/images/type-setting/scan_preview.svg">
                            </div>
                            <b-card style="height: 250px;" class="blockPreview__cardPreviewScanItems" header-tag="header" body-class="d-flex flex-column align-items-center" footer-tag="footer">
                              <template #header>
                                <div class="d-flex layoutHeader align-items-center justify-content-between">
                                  <div class="layoutHeader__left">
                                    <span class="icon material-icons material-icons-outlined">
                                      keyboard_arrow_left
                                    </span>
                                    <div class="circles"></div>
                                    <div class="line">
                                      <div class="line__on"></div>
                                      <div class="line__down"></div>
                                    </div>
                                  </div>
                                  <div class="layoutHeader__right">
                                    <div class="lineStart"></div>
                                    <div class="lineCenter"></div>
                                    <div class="lineEnd"></div>
                                    <div class="blockColor"></div>
                                  </div>
                                </div>
                              </template>
                              <b-card-title>スキャンしてください</b-card-title>
                              <div
                                class="d-flex justify-content-xl-between justify-content-center align-items-center w-100"
                                v-for="(scan, index) in scanItemsTable[tabActive]"
                                :key="index"
                              >
                                <template v-if="scan.isVisible === 1 && scanItemsRequest[scan.workType][scan.items[0].fieldId] === 1">
                                  <label for="inputField" class="fieldLabel col-5 px-0 mb-2">
                                    {{scanItemsRequest[scan.workType][`${scan.items[0].fieldId}Name`]}}
                                  </label>
                                  <div class="col-7 mb-2 inputFieldWrap">
                                    <i class="material-icons">flip_black</i>
                                    <b-form-input
                                      class="inputField"
                                      id="inputField"
                                      type="text"
                                      placeholder="スキャン"
                                      readonly
                                    />
                                  </div>
                                </template>
                              </div>
                              <template #footer>
                                <div class="d-flex layoutFooter align-items-center justify-content-between">
                                  <div class="layoutFooter__left">
                                    <div class="blockWhiteColor"></div>
                                    <div class="line">
                                      <div class="line__on"></div>
                                      <div class="line__down"></div>
                                    </div>
                                  </div>
                                  <div class="layoutFooter__right">
                                    <div class="blockBlueColor"></div>
                                  </div>
                                </div>
                              </template>
                            </b-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- SCAN ITEMS - END -->
              </div>
              <!-- title -->
              <div class="modal-right__title d-flex justify-content-between align-items-center mb-0">
                <div class="d-flex align-items-center mb-4">
                  <h4>スキャンコードの抜き出し</h4>
                  <tooltip-component
                    :title="'スキャンしたコードを加工することができます。加工後のコードで仕分けし、タスク明細への記録を行います。'"
                  />
                </div>
              </div>
              <div class="switch-btn-wrapper mb-2">
                <switch-button
                  v-model="taskTypeSettingForm['extractScanCodeSetting']"
                  id="radios-extract-scanCode"
                  activeLabel="無効"
                  inactiveLabel="有効"
                  :checked="taskTypeSettingForm['extractScanCodeSetting']"
                />
              </div>
              <!-- box -->
              <div v-if="taskTypeSettingForm['extractScanCodeSetting'] === 1" class="scan-code">
                <!-- form group -->
                <div class="form-group pl-0">
                  <div class="form-group__label">
                    <span>抜き出し位置</span>
                    <span class="required">必須</span>
                  </div>
                  <div class="scan-code__group-len d-flex align-items-center justify-content-between">
                    <div>
                      <div class="form-group__control scan-code__input-position d-flex align-items-center mb-2">
                        <ValidationProvider
                          ref="scanCodeCutoutStartPos"
                          mode="passive"
                          name="文字目から"
                          :rules="`required|min_value:1`"
                          v-slot="{ errors }"
                        >
                          <div class="d-flex align-items-center">
                            <input-number-component
                            class="w-100"
                            id="scanCodeCutoutStartPos"
                            :minValue="scanCodeCutoutPosMinVal"
                            :maxValue="scanCodeCutoutPosMaxVal"
                            v-model.number="taskTypeSettingForm['scanCodeCutoutStartPos']"
                            :startField="true"
                            :constrainedMinValue="scanCodeCutoutStartPosMinVal"
                            :constrainedMaxValue="scanCodeCutoutStartPosMaxVal"
                            @onBlur="onBlurScanCodeCutoutPos(...arguments)"
                            :state="errors && errors.length ? true : false"
                            />
                            <span class="label">文字目から</span>
                          </div>
                          <!-- Handle Error Message -->
                          <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                            {{ errors[i] }}
                          </small>
                        </ValidationProvider>
                      </div>
                      <div class="form-group__control scan-code__input-position d-flex align-items-center">
                        <ValidationProvider
                          ref="scanCodeCutoutEndPos"
                          mode="passive"
                          name="文字目まで"
                          :rules="`required|min_value:0`"
                          v-slot="{ errors }"
                        >
                          <div class="d-flex align-items-center">
                            <input-number-component
                              class="w-100"
                              id="scanCodeCutoutEndPos"
                              :minValue="scanCodeCutoutPosMinVal"
                              :maxValue="scanCodeCutoutPosMaxVal"
                              v-model.number="taskTypeSettingForm['scanCodeCutoutEndPos']"
                              :endField="true"
                              :constrainedMinValue="scanCodeCutoutEndPosMinVal"
                              :constrainedMaxValue="scanCodeCutoutEndPosMaxVal"
                              @onBlur="onBlurScanCodeCutoutPos(...arguments)"
                              :state="errors && errors.length ? true : false"
                            />
                            <span class="label">文字目まで</span>
                          </div>
                          <!-- Handle Error Message -->
                          <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                            {{ errors[i] }}
                          </small>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="scan-code__position">
                      <div class="number"><span>1234567890123</span>45</div>
                      <img src="../../assets/images/type-setting/bar_code.svg">
                      <div class="des">スキャンコード</div>
                    </div>
                  </div>
                </div>
                <!-- form group -->
                <div class="form-group pl-0">
                  <div class="form-group__label">
                    <span>0埋め</span>
                    <span class="required">必須</span>
                  </div>
                  <!-- radio -->
                  <div class="radio-custom radio-custom--row">
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="scanCodeZeroPaddingRule"
                      value="NONE"
                      :checked="taskTypeSettingForm['scanCodeZeroPaddingRule'] === 'NONE'"
                      v-model="taskTypeSettingForm['scanCodeZeroPaddingRule']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title scan-code__title">0埋め無し</div>
                        <div class="radio-custom__content">
                          <div class="scan-code__number-fill">123</div>
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="scanCodeZeroPaddingRule"
                      value="LEFT"
                      :checked="taskTypeSettingForm['scanCodeZeroPaddingRule'] === 'LEFT'"
                      v-model="taskTypeSettingForm['scanCodeZeroPaddingRule']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title scan-code__title">左に0埋め</div>
                        <div class="radio-custom__content">
                          <div class="scan-code__number-fill"><span>0</span>123</div>
                        </div>
                      </div>
                    </label>
                    <!-- item -->
                    <label class="radio-custom__item">
                      <input
                      type="radio"
                      name="scanCodeZeroPaddingRule"
                      value="RIGHT"
                      :checked="taskTypeSettingForm['scanCodeZeroPaddingRule'] === 'RIGHT'"
                      v-model="taskTypeSettingForm['scanCodeZeroPaddingRule']"
                      >
                      <span class="radio-custom__checkmark"></span>
                      <div class="radio-custom__overlay"></div>
                      <div class="radio-custom__body">
                        <div class="radio-custom__title scan-code__title">右に0埋め</div>
                        <div class="radio-custom__content">
                          <div class="scan-code__number-fill">123<span>0</span></div>
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div v-if="taskTypeSettingForm['scanCodeZeroPaddingRule'] !== 'NONE'" class="d-flex align-items-center justify-content-between">
                  <div class="form-group pl-0">
                    <div class="form-group__label">
                      <span>最大桁数</span>
                      <span class="required">必須</span>
                    </div>
                    <div class="form-group__control scan-code__input-last-digit">
                      <ValidationProvider
                        mode="passive"
                        name="最大桁数"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <input-number-component
                          id="scanCodeMaxLen"
                          @blur="cleanValidity('scanCodeMaxLen')"
                          :minValue="scanCodeMaxLenMinVal"
                          :maxValue="scanCodeMaxLenMaxVal"
                          v-model.number="taskTypeSettingForm['scanCodeMaxLen']"
                          :state="errors && errors.length ? true : false"
                        />
                        <!-- Handle Error Message -->
                        <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                          {{ errors[i] }}
                        </small>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="scan-code__position scan-code__position--sm">
                    <div class="number"><span v-if="taskTypeSettingForm['scanCodeZeroPaddingRule'] === 'LEFT'">00</span>1234567890123<span v-if="taskTypeSettingForm['scanCodeZeroPaddingRule'] === 'RIGHT'">00</span></div>
                    <img src="../../assets/images/type-setting/bar_code.svg">
                    <div class="des">スキャンコード</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- step 4 -->
            <div v-else-if="step === 4" class="step-4">
              <!-- title -->
              <!-- <div class="modal-right__title">
                  <h4>箱の回収方法（複数選択可）</h4>
                  <task-type-setting-tooltip
                    :title="`Dummy text`"
                  />
              </div> -->
              <!-- checkbox -->
              <!-- <div class="checkbox-custom checkbox-custom--col-2">
                <label class="checkbox-custom__item">
                  <input type="checkbox" name="selectManual" value="1" checked="true">
                  <span class="checkbox-custom__checkmark"></span>
                  <div class="checkbox-custom__overlay"></div>
                  <div class="checkbox-custom__body">
                    <div class="checkbox-custom__title">手動で回収</div>
                    <div class="checkbox-custom__content">
                      <img src="../../assets/images/type-setting/collect_manual.svg">
                    </div>
                  </div>
                </label>
              </div> -->
              <!-- title -->
              <div class="modal-right__title d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <h4>満杯センサ</h4>
                  <tooltip-component
                    :title="'追加デバイスの「満杯センサ」を設置する場合に有効にしてください。ダッシュボードのシュート進捗で満杯になったシュートにアラートを表示します。'"
                  />
                </div>
                <div class="switch-btn-wrapper">
                  <switch-button
                    v-model="taskTypeSettingForm['arSensorUse']"
                    id="radio-ar-sensor-use"
                    activeLabel="無効"
                    inactiveLabel="有効"
                    :checked="taskTypeSettingForm['arSensorUse']"
                  />
                </div>
              </div>
              <!-- box -->
              <div v-if="taskTypeSettingForm['arSensorUse'] === 1" class="box-input">
                <div class="box-input__title">
                  <h5>満杯検知レベル</h5>
                  <span class="required">必須</span>
                </div>
                <p class="box-input__content">シュートに設置したスロープの下から</p>
                <div class="box-input__group d-flex align-items-center">
                  <ValidationProvider
                    mode="passive"
                    name="満杯検知レベル"
                    rules="min_value:1|max_value:30|required"
                    v-slot="{ errors }"
                  >
                    <div class="d-flex align-items-center">
                      <input-number-component
                        :maxValue="30"
                        :minValue="1"
                        :id="'fullChuteLevel'"
                        v-model.number="taskTypeSettingForm['fullChuteLevel']"
                        :state="errors && errors.length ? true : false"
                      />
                      <span>個目のARマーカーまで埋まったらアラート</span>
                    </div>
                    <!-- Handle Error Message -->
                    <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                      {{ errors[i] }}
                    </small>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <!-- control -->
            <div class="group-control d-flex align-items-center justify-content-center" >
              <b-button v-if="step !== 1" type="button" class="btn-prev" @click="handlePrevStep">前へ</b-button>
              <b-button v-if="step !== 3" type="button" class="btn-info border-info" @click.prevent="handleNextStep">次へ</b-button>
            </div>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import TooltipComponent from '../../components/custom-components/TooltipComponent.vue'
import draggable from 'vuedraggable'
import EditableLabel from '../custom-components/EditableLabel.vue'
import FlashMessage from '../../common/flash-message.component'
import AlertMessageComponent from '../custom-components/AlertMessageComponent.vue'
import InputNumberComponent from '../custom-components/InputNumberComponent.vue'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import InputTextComponent from '../custom-components/InputTextComponent.vue'
import SwitchButton from '../custom-components/SwitchButton.vue'
// eslint-disable-next-line camelcase
import { min_value, excluded } from 'vee-validate/dist/rules'
import { mapGetters } from 'vuex'
import AppConstants from '../../constants/app.constants'
import { WorkInstructionFlag } from '../../enums/work-instruction.enums'
extend('min_value', {
  // eslint-disable-next-line camelcase
  ...min_value,
  message: '1以上で入力してください。'
})
extend('customExcluded', {
  // eslint-disable-next-line camelcase
  ...excluded,
  message: '登録しようとしたタスクタイプ番号は登録されています。別の番号にしてください。'
})
const NORMAL_SORT = 1
// const HAND_SORT = 2
// const MULTI_SORT = 3

const ADD_MODAL = 0
const EDIT_MODAL = 1
const CLONE_MODAL = 2
const UPDATE_TIME_KEY = 'updateTime'
const TASK_TYPE_KEY = 'taskType'
const INFORMATION_STEP = 1
const SORTING_RULES_STEP = 2
const INPUT_OR_SCAN_STEP = 3
const BOX_COLLECTION_STEP = 4
const SCAN_CODE_CUTOUT_POS_MIN_VAL = 1
const SCAN_CODE_CUTOUT_POS_MAX_VAL = 128
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    TooltipComponent,
    draggable,
    EditableLabel,
    AlertMessageComponent,
    InputNumberComponent,
    FormSelectComponent,
    InputTextComponent,
    SwitchButton
  },
  data() {
    return {
      step: 1,
      stepLists: [],
      enableSubmit: false,
      workingModes: [],
      sortingSetting: {},
      sortingSettingSelected: [],
      sortingSettingList: [],
      scanItems: [],
      taskTypeSettingForm: {},
      originalTabsMenu: {},
      originalSelectedWorkType: [],
      tabsMenu: [],
      tabActive: null,
      movingIndex: null,
      futureIndex: null,
      scanItemsTable: {},
      scanItemsRequest: {},
      scanItemsForNameComparison: {},
      editMode: null,
      typeModal: null,
      wmsName: '',
      titleTableScanItem: '',
      maxTaskType: 127,
      minTaskType: 0,
      titleHeaderModal: '',
      assignKeySelects: 1,
      minContinuousEntryTimes: 1,
      maxContinuousEntryTimes: 999,
      scanCodeCutoutPosMinVal: SCAN_CODE_CUTOUT_POS_MIN_VAL,
      scanCodeCutoutPosMaxVal: SCAN_CODE_CUTOUT_POS_MAX_VAL,
      scanCodeMaxLenMinVal: SCAN_CODE_CUTOUT_POS_MIN_VAL,
      scanCodeMaxLenMaxVal: SCAN_CODE_CUTOUT_POS_MAX_VAL,
      scanCodeCutoutStartPosMinVal: SCAN_CODE_CUTOUT_POS_MIN_VAL,
      scanCodeCutoutStartPosMaxVal: SCAN_CODE_CUTOUT_POS_MAX_VAL,
      scanCodeCutoutEndPosMinVal: SCAN_CODE_CUTOUT_POS_MIN_VAL,
      scanCodeCutoutEndPosMaxVal: SCAN_CODE_CUTOUT_POS_MAX_VAL,
      taskTypeSettingTooltipMap: new Map(),
      originalTaskTypeSettingForm: {},
      messageConfirmModal: '',
      originalSortingSettingList: [],
      originalScanItemsRequest: {},
      isCloseModal: false,
      taskTypeList: [],
      originalWorkTypeList: [],
      preUpdateTimeFieldValue: null,
      newItemData: {},
      beNotifiedSocket: false,
      taskTypeId: 0,
      isEditModal: false,
      originalWorkInstruction: null
    }
  },
  props: ['id', 'objectDefaultData', 'pRejectChuteNo', 'taskTypeData', 'showManualSortSetting', 'enableMultiSortSetting'],
  created() {
    this.$_fetch_setting()
  },
  computed: {
    isClose() {
      return !!(this.typeModal === ADD_MODAL || this.typeModal === CLONE_MODAL)
    }
  },
  watch: {
    stepLists(newValue) {
      // const checkArr = [INFORMATION_STEP, SORTING_RULES_STEP, INPUT_OR_SCAN_STEP] // step 1, 2, 3
      const checkArr = [INFORMATION_STEP, SORTING_RULES_STEP] // step 1, 2
      this.enableSubmit = checkArr.every(x => newValue.includes(x)) || this.typeModal === CLONE_MODAL
    }
  },
  methods: {
    ...mapGetters('setting', ['getSetting']),
    cleanValidity(id) {
      const input = document.getElementById(id)
      if (!input.checkValidity()) {
        input.setCustomValidity('')
      }
    },
    /**
     * HANDLE CHECK DISPLAY ICON FILTER AND ICON DRAG
     */
    displayEditAdDragIcon(index, isCheck) {
      let styleDrag = document.getElementById(`dragIcon_${index}`).style
      let styleEdit = document.getElementById(`editIcon_${index}`).style
      if (isCheck) {
        styleDrag.visibility = 'visible'
        styleEdit.visibility = 'visible'
      }
      if (!isCheck) {
        styleDrag.visibility = 'hidden'
        styleEdit.visibility = 'hidden'
      }
    },
    /**
     * データ変更通知時に編集モーダルにエラーメッセージを表示する場合にチェック
     */
    async checkToShowErrorMsgOnEditModal() {
      this.beNotifiedSocket = true
      // 編集中のレコードの最新データを取得する
      await this.getCurrentItemData()
      setTimeout(() => {
        if (this.isEditModal) {
          // 最後の update_time 値を編集前の update_time と比較すると、エラー メッセージが表示されます
          if (!this.newItemData[UPDATE_TIME_KEY] || (this.newItemData[UPDATE_TIME_KEY] !== this.preUpdateTimeFieldValue && this.newItemData[TASK_TYPE_KEY] === this.taskTypeId)) {
            FlashMessage.getInstance().showErrorMessage('編集内容に変更があったため、保存できませんでした。編集中の画面を閉じて更新してください。')
          }
        }
      }, 250)
    },
    /**
     * 編集モーダルで編集中の現在のレコードを取得する
     */
    async getCurrentItemData() {
      this.newItemData = {}
      if (this.isEditModal && this.beNotifiedSocket) {
        // 全タスク種別設定データ取得
        const res = await this.$axios.get('/setting/task-type')
        if (res && res.data) {
          const listTaskTypeSetting = res.data.listTaskType
          // 編集中のレコードの最新データを取得する
          this.newItemData = {...listTaskTypeSetting.find(taskType => taskType[TASK_TYPE_KEY] === this.taskTypeId)}
        }
      }
    },
    async showModal(data = null, noEditing) {
      this.beNotifiedSocket = false
      this.typeModal = noEditing
      if (data && noEditing === EDIT_MODAL) {
        this.preUpdateTimeFieldValue = data[UPDATE_TIME_KEY]
        this.taskTypeId = data[TASK_TYPE_KEY]
        this.isEditModal = true
      } else {
        this.taskTypeId = 0
        this.preUpdateTimeFieldValue = null
        this.isEditModal = false
      }
      // Initialize the initial default value for the variable
      await this.initValueForField()
      // Build template add/edit modal
      await this.filterArrayByCategory(data, noEditing)
      this.handleDisplayTitleTableScanItem(this.tabActive)
      this.setScanCodeCutoutEndPos(this.taskTypeSettingForm['scanCodeCutoutStartPos'], this.taskTypeSettingForm['scanCodeCutoutLen'])
      if (this.isOnlyNoTaskSortUseCase && noEditing === ADD_MODAL) {
        this.$set(this.taskTypeSettingForm, 'workInstruction', WorkInstructionFlag.NO_WORK_INSTRUCTION)
        this.buildScanItemForNoWorkInstruction()
      }
      this.originalTaskTypeSettingForm = {...this.taskTypeSettingForm}
      this.setOriginalScanItemsRequest()
      this.setScanCodeCutoutPosMinMaxVal()
      this.isCloseModal = false
      this.$bvModal.show(this.id)
      this.originalWorkInstruction = this.taskTypeSettingForm[AppConstants.WORK_INSTRUCTION_KEY]
    },
    // set the end position of Scan Code
    setScanCodeCutoutEndPos(scanCodeCutoutStartPos, scanCodeCutoutLen) {
      const scanCodeCutoutEndPos = scanCodeCutoutStartPos + scanCodeCutoutLen
      this.$set(this.taskTypeSettingForm, 'scanCodeCutoutEndPos', scanCodeCutoutEndPos)
      this.taskTypeSettingForm['scanCodeCutoutStartPos'] += 1
    },
    // get len position of Scan Code
    getScanCodeCutoutLen() {
      return this.taskTypeSettingForm['scanCodeCutoutEndPos']
        ? this.taskTypeSettingForm['scanCodeCutoutEndPos'] - this.taskTypeSettingForm['scanCodeCutoutStartPos'] + 1
        : this.originalTaskTypeSettingForm['scanCodeCutoutLen']
    },
    setOriginalScanItemsRequest() {
      Object.keys(this.scanItemsRequest).forEach(key => {
        this.originalScanItemsRequest[key] = {...this.scanItemsRequest[key]}
      })
    },
    updateIsCloseModal(param) {
      this.isCloseModal = param
    },
    closeModal(event = null) {
      // データが変更された場合、isCloseModal変数=falseで、イベント変数がnullでない場合は、モーダルを閉じず、モーダル確認を表示します
      if (!this.isCloseModal && this.isDataChanged() && event) {
        event.preventDefault()
        this.showMessageConfirm(this.id)
      } else {
        this.beNotifiedSocket = false
        this.isEditModal = false
        this.isCloseModal = true
        this.$bvModal.hide(this.id)
      }
    },
    isDataChanged() {
      let isChange = this.checkTaskTypeChanged() || this.checkSortingSettingChanged() || this.checkScanItemsChanged()
      return isChange
    },
    showMessageConfirm(id) {
      this.$bvModal.msgBoxConfirm(`${this.messageConfirmModal}`, {
        title: '閉じてもよろしいですか？',
        size: 'sm',
        okVariant: 'link text-dark text-decoration-none',
        cancelVariant: 'link text-dark text-decoration-none',
        okTitle: 'OK',
        cancelTitle: 'キャンセル',
        id: 'modal-confirm',
        footerClass: 'justify-content-around p-1',
        hideHeaderClose: false,
        class: 'modalConfirm',
        centered: true
      })
        .then(isConfirm => {
          if (isConfirm) {
            this.isCloseModal = isConfirm
            this.$bvModal.hide(id)
          }
        })
        .catch(() => {})
    },
    checkTaskTypeChanged() {
      let keys = Object.keys(this.originalTaskTypeSettingForm).filter(item => !item.includes('sortingSetting'))
      let isTaskTypeChanged = keys.some(key => {
        if (!this.originalTaskTypeSettingForm[key] && !this.taskTypeSettingForm[key]) {
          this.originalTaskTypeSettingForm[key] = this.taskTypeSettingForm[key]
          return false
        }
        if (Array.isArray(this.taskTypeSettingForm[key])) {
          return this.originalTaskTypeSettingForm[key].length !== this.taskTypeSettingForm[key].length
        }
        return this.originalTaskTypeSettingForm[key] !== this.taskTypeSettingForm[key]
      })
      return isTaskTypeChanged
    },
    checkSortingSettingChanged() {
      let isSortingSettingChanged = false
      this.sortingSettingSelected = this.sortingSettingSelected.filter(value => !!value)
      if (this.originalSortingSettingList.length === this.sortingSettingList.length) {
        isSortingSettingChanged = this.originalSortingSettingList.some((sortingSettingSelected, index) =>
          this.sortingSettingSelected[index] !== sortingSettingSelected)
      } else {
        isSortingSettingChanged = this.originalSortingSettingList.length !== this.sortingSettingList.length
      }
      return isSortingSettingChanged
    },
    checkScanItemsChanged() {
      let isScanItemChanged = false
      let keyScanItems = []
      Object.keys(this.originalScanItemsRequest[1]).forEach(key => {
        keyScanItems.push(key)
      })
      keyScanItems.forEach(keyScanItem => {
        this.originalTaskTypeSettingForm['workType'].forEach(key => {
          if (this.originalScanItemsRequest[key][keyScanItem] !== this.scanItemsRequest[key][keyScanItem]) {
            isScanItemChanged = true
          }
        })
      })
      return isScanItemChanged
    },
    doSave() {
      if (this.checkDuplicateSortingSettingKey()) {
        return
      }
      this.$refs.formSubmit.validate().then(success => {
        if (!success) {
          return
        }
        // 最後のモーダルステップを確認してください
        if (this.step === INPUT_OR_SCAN_STEP && this.typeModal === ADD_MODAL) {
          if (this.stepLists.indexOf(this.step) === -1) {
            this.stepLists.push(this.step)
          }
        }
        // Filter and reassign model value for data form
        const scanItemListCompleted = []
        this.setValueDefaultTaskTypeSettingForm()
        let taskTypeSettingFormCopied = {...this.taskTypeSettingForm}
        // 作業タイプに関係なくユーザーが定義した場合、スキャン項目を保存します
        this.originalWorkTypeList.forEach(key => {
          scanItemListCompleted.push(this.scanItemsRequest[key])
        })
        taskTypeSettingFormCopied['sortingSetting'] = this.sortingSettingSelected.filter(value => !!value).join()
        taskTypeSettingFormCopied['scanItemList'] = scanItemListCompleted
        taskTypeSettingFormCopied['scanCodeCutoutStartPos'] -= 1
        taskTypeSettingFormCopied['scanCodeCutoutLen'] = this.getScanCodeCutoutLen()
        delete taskTypeSettingFormCopied['sort']
        delete taskTypeSettingFormCopied['isDisplayButton']
        delete taskTypeSettingFormCopied['sortCount']
        this.$emit('on-submit', taskTypeSettingFormCopied, this.id, this.typeModal)
      })
    },
    setScrollBarOnTop() {
      let modalId = document.getElementById('modal-right')
      if (window.innerWidth < 900) {
        modalId = document.getElementById('sorting')
      }
      modalId.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    setScrollBarToBottom() {
      let modalId = document.getElementById('modal-right')
      if (window.innerWidth < 900) {
        modalId = document.getElementById('sorting')
      }
      this.$nextTick(() => {
        modalId.scrollTo({
          top: modalId.scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    setValueDefaultTaskTypeSettingForm() {
      let keyInputFields = ['continuousEntryTimes', 'scanCodeCutoutStartPos', 'scanCodeCutoutLen', 'scanCodeMaxLen', 'fullChuteLevel']
      Object.keys(this.taskTypeSettingForm).map(key => {
        if (!this.taskTypeSettingForm[key] && keyInputFields.includes(key)) {
          this.taskTypeSettingForm[key] = this.originalTaskTypeSettingForm[key]
        }
      })
    },
    handleNextStep() {
      this.setTaskTypeList()
      this.$nextTick().then(res => {
        this.nextStep()
      })
    },
    handlePrevStep() {
      this.$nextTick().then(res => {
        this.prevStep()
      })
    },
    handleDoSave() {
      // 編集モーダルが表示され、ソケットが通知される場合
      // update_time フィールドの値が一致しない場合、送信されません.
      if (this.beNotifiedSocket && this.isEditModal && this.newItemData[UPDATE_TIME_KEY] !== this.preUpdateTimeFieldValue) {
        FlashMessage.getInstance().showErrorMessage('編集内容に変更があったため、保存できませんでした。編集中の画面を閉じて更新してください。')
        return
      }
      this.setTaskTypeList()
      this.$nextTick().then(res => {
        this.doSave()
      })
    },
    // next step modal
    nextStep() {
      if (this.checkDuplicateSortingSettingKey()) {
        return
      }
      this.$refs.formSubmit.validate().then(success => {
        if (!success) {
          return
        }
        // check last step
        if (this.step === BOX_COLLECTION_STEP) {
          return
        }

        if (this.step === INPUT_OR_SCAN_STEP && !this.checkRequiredWorkType()) {
          FlashMessage.getInstance().showErrorMessage('投入方法を選択してください。')
          return
        }

        // push step to array
        if (this.stepLists.indexOf(this.step) === -1) {
          this.stepLists.push(this.step)
        }

        // add step
        this.step++
        FlashMessage.getInstance().hideAllMessages()
        this.setScrollBarOnTop()
      })
    },
    // prev step modal
    prevStep() {
      if (this.checkDuplicateSortingSettingKey()) {
        return
      }
      this.$refs.formSubmit.validate().then(success => {
        if (!success) {
          return
        }

        // check first step
        if (this.step === INFORMATION_STEP) {
          return
        }

        if (this.step === INPUT_OR_SCAN_STEP && !this.checkRequiredWorkType()) {
          FlashMessage.getInstance().showErrorMessage('投入方法を選択してください。')
          return
        }

        // sub step
        this.step--
        FlashMessage.getInstance().hideAllMessages()
        this.setScrollBarOnTop()
      })
    },
    checkDuplicateSortingSettingKey() {
      if (new Set(this.sortingSettingSelected).size !== this.sortingSettingSelected.length) {
        FlashMessage.getInstance().showErrorMessage(`割当キー${this.getIndexHasDuplicated()}が重複しています。`)
        return true
      }
      return false
    },
    // ソート設定キーのインデックスが重複していることを返す
    getIndexHasDuplicated() {
      var duplicates = {}
      this.sortingSettingSelected.forEach((selected, index) => {
        if (duplicates.hasOwnProperty(selected)) {
          // 選択した「duplicates」変数のインデックスを追加します
          duplicates[selected].push(index)
        } else if (this.sortingSettingSelected.lastIndexOf(selected) !== index) {
          // 「sortSettingSelected」変数が複製されるときに、「duplicates」変数のプロパティを追加します
          duplicates[selected] = [index]
        }
      })
      let indexSelectedDuplicates = Object.values(duplicates)[0]
      let paramIndex = ''
      // エラーメッセージパラメータを追加する
      indexSelectedDuplicates.forEach((key, index) => {
        if (index === 0) {
          paramIndex += `${key + 1}`
        } else {
          paramIndex += `と${key + 1}`
        }
      })
      return paramIndex
    },
    // add sorting setting
    addSortingSetting() {
      this.sortingSettingSelected = this.sortingSettingSelected.filter(value => !!value)
      if (this.sortingSettingSelected.length === 5 || this.sortingSettingSelected.length === this.sortingSetting.items.length) {
        return
      }
      let options = [...this.sortingSetting.items]
      this.sortingSettingSelected.push(options[0] ? options[0].itemValue : '')
      this.sortingSettingList.push(options[0].itemValue)
      this.$nextTick(() => {
        this.setScrollBarToBottom()
      })
    },
    removeSortingSetting(indx) {
      if (this.sortingSettingSelected.length === 1) {
        return
      }
      this.sortingSettingSelected.splice(indx, 1)
      this.sortingSettingList.splice(indx, 1)
    },
    async filterArrayByCategory(data, noEditing) {
      if (!data || !this.objectDefaultData.fieldList) {
        return
      }
      const defaultScanItems = this.objectDefaultData.fieldList.filter(el => el.category === 1)
      // GET TASK TYPE SETTING INFO
      this.createdTaskTypeInfoForm(data, noEditing)
      let workType = null
      if (data.workType === '') {
        workType = noEditing === ADD_MODAL ? [1] : []
      }
      for (let key in data.fieldList) {
        const taskTypeField = data.fieldList[key]
        if (taskTypeField['category'] === 1) {
          // Filter and construct the elements for the table below
          this.scanItems.push(taskTypeField)
        } else {
          // Filter and construct elements for the radio and checkbox input on the template
          this.createdWorkingModesForm(taskTypeField, workType)
          this.workingModes.push(taskTypeField)
          // Push sorting setting
          if (taskTypeField.category === 2) {
            this.sortingSetting = taskTypeField
            this.sortingSettingSelected = this.sortingSetting.selectedResult.split(',')
            this.sortingSettingList = [...this.sortingSettingSelected]
            this.originalSortingSettingList = [...this.sortingSettingSelected]
          }
          if (!taskTypeField.category && taskTypeField.items[0]) {
            let contentTooltip = taskTypeField.helpComment
            const item = taskTypeField.items[0]
            if (item.fieldId === 'workType' && !this.showManualSortSetting) {
              contentTooltip = contentTooltip.replace(/手仕分け.*$/, '')
            }
            this.taskTypeSettingTooltipMap.set(taskTypeField.items[0].fieldId, contentTooltip)
          }
        }
      }
      /**
       * SORT LIST AND ITEMS
       */
      this.sortListAndItems(this.workingModes)
      this.sortListAndItems(this.scanItems)
      /**
       * CREATE ORIGINAL TABS MENU
       */
      this.createdOriginalTabsMenu(this.workingModes)
      /**
       * SORT LIST DEFAULT
       */
      this.sortListAndItems(defaultScanItems)

      this.createdScanItemsForm(this.scanItems)
      this.createdScanItemsForm(defaultScanItems, true)
      /**
       * CREATE TAB LIST
       */
      this.createdTabsMenu(this.taskTypeSettingForm['workType'])
      /**
       * CREATE ORIGINAL SELECTED WORK TYPE
       */
      this.originalSelectedWorkType = [...this.taskTypeSettingForm['workType']]
      /**
       * CUSTOM ORDER NUMBER FIELD INTO SCAN ITEMS TABLE
       */
      this.insertOrderNumberFieldIntoScanTable()
    },
    /**
     * CREATE FORM DATA TASK TYPE INFO
     */
    createdTaskTypeInfoForm(data, noEditing) {
      if (!data) {
        return
      }
      this.step = INFORMATION_STEP
      let dataCloned = { ...data }
      delete dataCloned.fieldList
      switch (noEditing) {
        case ADD_MODAL:
          dataCloned[TASK_TYPE_KEY] = null
          const oldTaskType = this.isOnlyNoTaskSortUseCase ? AppConstants.DEFAULT_NO_TASK_SORT : AppConstants.DEFAULT_ORDER_TASK_SORT
          this.$set(this.taskTypeSettingForm, 'oldTaskType', oldTaskType)
          this.titleHeaderModal = 'タスクタイプの追加'
          this.stepLists = []
          this.messageConfirmModal = '編集中の項目を破棄してタスクタイプの追加画面を閉じますか？'
          break
        case CLONE_MODAL:
          const taskTypeCopied = dataCloned[TASK_TYPE_KEY]
          dataCloned[TASK_TYPE_KEY] = null
          dataCloned['reserveItem1'] = 1
          dataCloned['isDisplayButton'] = true
          this.$set(this.taskTypeSettingForm, 'oldTaskType', taskTypeCopied)
          this.titleHeaderModal = 'タスクタイプの複製'
          this.stepLists = [2, 3]
          this.messageConfirmModal = '編集中の項目を破棄してタスクタイプの複製画面を閉じますか？'
          break
        case EDIT_MODAL:
          this.$set(this.taskTypeSettingForm, 'oldTaskType', dataCloned[TASK_TYPE_KEY])
          this.titleHeaderModal = 'タスクタイプの編集'
          this.stepLists = [1, 2, 3]
          this.messageConfirmModal = '保存ボタンを押すまでは、変更した内容は反映されません。タスクタイプの編集画面を閉じますか？'
          break
        default:
          break
      }
      for (let taskTypeInfoKey in dataCloned) {
        this.$set(
          this.taskTypeSettingForm,
          taskTypeInfoKey,
          dataCloned[taskTypeInfoKey]
        )
      }
    },
    /**
     * CREATE FORM DATA WORKING MODES
     */
    createdWorkingModesForm(data, workType = null) {
      // Build UI and set default value for radio - checkbox input
      const keyName = data.items ? data.items[0].fieldId : null
      const keyValue =
      keyName === 'workType'
        ? (workType || this.reFormatSelectedResult(data.selectedResult))
        : this.reFormatSelectedResult(data.selectedResult, false)
      this.$set(this.taskTypeSettingForm, keyName, keyValue)
    },
    /**
     * CREATE FORM DATA SCAN ITEMS
     */
    createdScanItemsForm(scanItems, isDefault = false) {
      if (!scanItems) {
        return
      }
      const workTypes = []
      const scanItemsCopy = [...scanItems]
      const scanItemsRequestCopy = {}
      let scanItemsTableCopy = {}
      this.originalWorkTypeList = []

      // Init array contain work types
      scanItemsCopy.map(scanItem => {
        if (scanItem.workType !== null) {
          workTypes.push(scanItem.workType)
        }
      })
      // Remove the same value from the workTypes
      const uniqueWorkTypes = [...new Set(workTypes)]
      // 作業種別リストの初期化
      this.originalWorkTypeList = [...uniqueWorkTypes]
      uniqueWorkTypes.map(type => {
        // Init key and set default value for Object
        scanItemsRequestCopy[type] = {}
        if (!isDefault) scanItemsTableCopy[type] = []
      })
      // Group objects by work type
      scanItemsCopy.map(scanItem => {
        const scanItemCloned = {...scanItem}
        if (!isDefault) scanItemsTableCopy[scanItem.workType].push(scanItemCloned)
        const keyName = scanItem.items ? scanItem.items[0].fieldId : null
        const keyValue = this.reFormatSelectedResult(scanItem.selectedResult, false)
        const mapObj = scanItemsRequestCopy[scanItem.workType]
        mapObj['workType'] = scanItem.workType
        mapObj[keyName] = keyValue
        mapObj[`${keyName}Name`] = scanItem.htmlLabel
        mapObj[`${keyName}Sort`] = scanItem.fieldSort
      })
      if (!isDefault) {
        this.scanItemsRequest = {...scanItemsRequestCopy}
        this.scanItemsTable = {...scanItemsTableCopy}
      } else this.scanItemsForNameComparison = {...scanItemsRequestCopy}
    },
    insertOrderNumberFieldIntoScanTable() {
      if (!this.scanItemsTable) return
      // Loop retrieves list of data by work type
      for (let workType in this.scanItemsTable) {
        let index = 1
        if (!this.scanItemsTable[workType]) continue
        // Iterate over each item in the scanItems to insert the order field by isVisible
        this.scanItemsTable[workType].forEach(scanItem => {
          if (scanItem.isVisible) {
            scanItem['order'] = index
            index++
          }
        })
      }
    },
    /**
     * INITIALIZE THE INITIAL DEFAULT VALUE FOR THE VARIABLE
     */
    async initValueForField() {
      this.taskTypeSettingForm = {}
      this.scanItems = []
      this.workingModes = []
      this.scanItemsTable = {}
      this.scanItemsRequest = {}
      this.tabsMenu = []
      this.originalSelectedWorkType = []
      this.originalTaskTypeSettingForm = {}
      this.originalScanItemsRequest = {}
      this.originalSortingSettingList = []
    },
    /**
     * CREATE TAB LIST
     */
    createdTabsMenu(selectedWorkTypes) {
      if (!selectedWorkTypes || selectedWorkTypes.length === 0) {
        this.tabsMenu = []
        this.tabActive = 0
        return
      }
      for (let key in selectedWorkTypes) {
        this.tabsMenu.push(this.originalTabsMenu[selectedWorkTypes[key]])
      }
      this.tabsMenu.sort((a, b) => a.sort - b.sort)
      this.tabActive = this.tabsMenu[0]['value']
    },
    /**
     * CREATE ORIGINAL TABS MENU
     */
    createdOriginalTabsMenu(list) {
      if (!list) return
      for (let key in list) {
        const items = list[key]['items']
        if (items) {
          // And initialize original the meus tab of the checkbox
          for (let i in items) {
            if (items[i].itemValue === null || !items[i].itemLabel || !items[i].fieldId) {
              continue
            }
            if (items[i].fieldId === 'workType') {
              const itemTabMenu = { ...{ label: items[i].itemLabel, value: items[i].itemValue, sort: items[i].itemSort } }
              this.originalTabsMenu[items[i].itemValue] = itemTabMenu
            }
          }
        }
      }
    },
    /**
     * SORT LIST AND CREATE TAB MENUS
     */
    sortListAndItems(list) {
      if (!list) return
      // Sort the elements in ascending order
      list.sort((a, b) => a.fieldSort - b.fieldSort)
      for (let key in list) {
        const items = list[key]['items']
        let isString = false
        if (list[key]['category'] === 2) {
          isString = true
        }
        if (items) {
          for (let i in items) {
            if (items[i].itemValue === null) {
              continue
            }
            items[i].itemValue = isString ? items[i].itemValue : parseInt(items[i].itemValue)
          }
          // Sort the elements in ascending order
          items.sort((c, d) => c.itemSort - d.itemSort)
        }
      }
    },
    /**
     * CONVERT SELECTED RESULT FROM STRING TO (ARRAY OR NUMBER)
     */
    reFormatSelectedResult(selectedResult, isArray = true) {
      if (!selectedResult) {
        return
      }
      if (selectedResult.includes(',')) {
        return selectedResult.split(',').map(el => parseInt(el))
      }
      return isArray ? [parseInt(selectedResult)] : parseInt(selectedResult)
    },
    onChangeCheckBox(e, itemValue) {
      // Handle display tabs menu by work type checkbox changed
      const indexOf = this.tabsMenu.map(el => el.value).indexOf(itemValue)
      if (indexOf !== -1) {
        // If the work type value is unchecked,
        // the corresponding element in the tabs menu will be deleted
        this.tabsMenu.splice(indexOf, 1)
      } else {
        // If the work type value is checked,
        // the corresponding element will be added to the tabs menu
        this.tabsMenu.push(this.originalTabsMenu[itemValue])
      }
      this.handleActiveTabMenu(indexOf, itemValue)
      this.handleDisplayTitleTableScanItem(this.tabActive)
      this.tabsMenu.sort((a, b) => a.sort - b.sort)
    },
    checkRequiredWorkType() {
      return !!this.taskTypeSettingForm['workType'].length
    },
    onChangeTabMenu(value) {
      this.tabActive = value
      this.handleDisplayTitleTableScanItem(value)
    },
    /**
     * HANDLE ACTIVE THE TAB MENU
     */
    handleActiveTabMenu(indexOf, value) {
      // If at the time the tab is active but hidden,
      // it will switch active to the first tab in the list
      if (
        (indexOf !== -1 && this.tabActive === value && this.tabsMenu.length) ||
        (this.tabsMenu.length && !this.tabActive)
      ) {
        this.tabActive = this.tabsMenu[0]['value']
        return
      }
      // If all checkboxs are uncheck, the tabActive field will return to 0,
      // also will not init the scan items table
      if (!this.tabsMenu.length && this.tabActive) {
        this.tabActive = 0
      }
    },
    onChangeRadioButton(e, fieldId) {
      if (fieldId === 'workInstruction') {
        // ユースケースの選択に応じて、タスクタイプを有効または無効にします
        if (!this.hasUseCaseOnWorkInstruction(this.taskTypeSettingForm['workInstruction'])) {
          this.taskTypeSettingForm['isEnabled'] = 0
        } else {
          const enabledTaskTypeNum = this.taskTypeData && Array.isArray(this.taskTypeData)
            ? this.taskTypeData.filter(taskType => taskType.isEnabled === 1).length
            : 0
          if (enabledTaskTypeNum === 1) {
            this.taskTypeSettingForm['isEnabled'] = 1
          }
        }
        // '作業指示' の変更に基づいて '機能タイプ' を動的に設定し、適切な構成、つまり '単一投入' または元の選択を反映する
        if (this.taskTypeSettingForm[AppConstants.WORK_INSTRUCTION_KEY] !== this.originalWorkInstruction) {
          this.taskTypeSettingForm['workType'] = [NORMAL_SORT]
        } else {
          this.taskTypeSettingForm['workType'] = [...this.originalSelectedWorkType]
        }
        this.tabsMenu = []
        this.createdTabsMenu(this.taskTypeSettingForm['workType'])
        this.handleDisplayTitleTableScanItem(this.tabActive)
      }
    },
    /**
     * TRIGGER WHEN THE USER COMPLETES THE NAME CHANGE
     */
    onEditItemName(editedLabelName, data) {
      if (!data || !data.items) {
        return
      }
      this.scanItemsRequest[data.workType][`${data.items[0].fieldId}Name`] = editedLabelName
    },
    switchToEditMode(index, type) {
      this.$refs[`editLabel_${index}_${type}`][0].switchToEditMode()
    },
    isActiveCheckbox(fieldId, itemValue) {
      if (!fieldId || itemValue === null) {
        return
      }
      if (!this.taskTypeSettingForm[fieldId]) return
      return this.taskTypeSettingForm[fieldId].indexOf(itemValue) !== -1
    },
    /**
     * TRIGGER DRAG AND DROP COLUMN
     */
    onMoveColumnOrder(event) {
      const { index, futureIndex } = event.draggedContext
      this.movingIndex = index
      this.futureIndex = futureIndex
      return false // disable sort
    },
    /**
     * END DRAG AND DROP COLUMN
     */
    async onEndColumnOrder(e) {
      let scanItemsAfterDragging = this.scanItemsTable[this.tabActive]
      if (this.movingIndex === null || this.futureIndex === null) {
        return
      }
      if (this.futureIndex === scanItemsAfterDragging.length) {
        this.futureIndex = scanItemsAfterDragging.length - 1
      }
      let originalOrder = scanItemsAfterDragging[this.movingIndex].fieldSort
      let targetOrder = scanItemsAfterDragging[this.futureIndex].fieldSort
      const isDragToBottom = originalOrder < targetOrder
      const increment = isDragToBottom ? -1 : 1
      if (isDragToBottom) {
        for (let i = this.movingIndex; i <= this.futureIndex; i++) {
          if (this.movingIndex === i) {
            scanItemsAfterDragging[this.movingIndex].fieldSort = targetOrder
          } else {
            scanItemsAfterDragging[i].fieldSort = scanItemsAfterDragging[i].fieldSort + increment
          }
        }
      } else {
        for (let j = this.futureIndex; j <= this.movingIndex; j++) {
          if (this.futureIndex === j || j !== this.movingIndex) {
            scanItemsAfterDragging[j].fieldSort = scanItemsAfterDragging[j].fieldSort + increment
          } else {
            scanItemsAfterDragging[j].fieldSort = targetOrder
          }
        }
      }
      scanItemsAfterDragging.sort((a, b) => a.fieldSort - b.fieldSort)
      let scanItemsRequest = this.scanItemsRequest[this.tabActive]
      let scanItemsForNameComparison = this.scanItemsForNameComparison[this.tabActive]
      let index = 1
      for (let k in scanItemsAfterDragging) {
        // Update value order number field for scan items table
        if (scanItemsAfterDragging[k].isVisible) {
          scanItemsAfterDragging[k]['order'] = index
          index++
        }
        if (!scanItemsAfterDragging[k].items[0]) continue
        // Update adds sort value to scanItems request field send to back end
        scanItemsRequest[`${scanItemsAfterDragging[k].items[0].fieldId}Sort`] =
          scanItemsAfterDragging[k].fieldSort
        // Synchronize the sort value for comparing the default name of the scan table
        scanItemsForNameComparison[`${scanItemsAfterDragging[k].items[0].fieldId}Sort`] =
          scanItemsAfterDragging[k].fieldSort
      }
      this.movingIndex = null
      this.futureIndex = null
    },
    /**
     * METHOD FOR COMPARING NAME CHANGES ON SCAN ITEMS TABLE
     */
    formatedLabelName(name, type, fieldId) {
      // If the changed name is different from the default name
      // then the default name will be added after the change
      if (name !== this.scanItemsForNameComparison[type][`${fieldId}Name`]) {
        return name.concat(' ', '(', this.scanItemsForNameComparison[type][`${fieldId}Name`], ')')
      }
      return name
    },
    $_fetch_setting() {
      const results = this.getSetting()
      if (!results || !results.data || !results.data.mstSetting) {
        return
      }

      const resultMstSetting = results.data.mstSetting

      this.wmsName = resultMstSetting.wmsName ? resultMstSetting.wmsName : ''
    },
    setTaskTypeList() {
      this.taskTypeList = []
      this.taskTypeData.forEach(taskTypeForm => {
        this.taskTypeList.push(taskTypeForm[TASK_TYPE_KEY])
      })
      if (this.typeModal === EDIT_MODAL) {
        this.taskTypeList = [...this.taskTypeList.filter(taskType => this.taskTypeSettingForm['oldTaskType'] !== taskType)]
      }
    },
    handleDisplayTitleTableScanItem(check) {
      if (!check) {
        this.titleTableScanItem = ''
        return
      }
      switch (check) {
        case 1:
          this.titleTableScanItem = 'ロボットに「商品をひとつ投入」するモードです。<br />表示選択した項目が、スキャン画面に表示されます。'
          break
        case 2:
          this.titleTableScanItem = 'ロボットを使わず「人の手で商品を投入」するモードです。<br />表示選択した項目が、スキャン画面に表示されます。'
          break
        default:
          this.titleTableScanItem = 'ロボットに「商品をまとめて投入」するモードです。<br />表示選択した項目が、スキャン画面に表示されます。'
          break
      }
    },
    isCloneModalType() {
      return this.typeModal === CLONE_MODAL
    },
    /**
     * 最小最大を設定スキャンコードの切り出し分野
     */
    setScanCodeCutoutPosMinMaxVal() {
      this.setStartMinMax(this.taskTypeSettingForm['scanCodeCutoutEndPos'])
      this.setEndMinMax(this.taskTypeSettingForm['scanCodeCutoutStartPos'])
    },
    /**
     * 最小最大を設定スキャンコードの切り出し開始位置
     * @param {number} endValue の値スキャンコードの切り出し長さ
     */
    setStartMinMax(endValue) {
      this.scanCodeCutoutStartPosMinVal = SCAN_CODE_CUTOUT_POS_MIN_VAL
      this.scanCodeCutoutStartPosMaxVal = endValue || SCAN_CODE_CUTOUT_POS_MAX_VAL
    },
    /**
     * 最小最大を設定スキャンコードの切り出し長さ
     * @param {number} startValue の値スキャンコードの切り出し開始位置
     */
    setEndMinMax(startValue) {
      this.scanCodeCutoutEndPosMinVal = startValue || SCAN_CODE_CUTOUT_POS_MIN_VAL
      this.scanCodeCutoutEndPosMaxVal = SCAN_CODE_CUTOUT_POS_MAX_VAL
    },
    /**
     * フォーカス喪失イベントを処理する
     * @param {string} fieldId
     * @param {number} fieldValue
     * @param {boolean} isValidInputField
     */
    onBlurScanCodeCutoutPos(fieldId, fieldValue, isValidInputField) {
      if (fieldId === 'scanCodeCutoutStartPos') {
        this.setEndMinMax(fieldValue)
      } else if (fieldId === 'scanCodeCutoutEndPos') {
        this.setStartMinMax(fieldValue)
      }
      const taskTypeSettingModalElement = document.getElementById(this.id)
      // 現在のステップが 3 の場合、警告メッセージが表示され、クリック イベントが停止します。
      if (!isValidInputField && this.step === INPUT_OR_SCAN_STEP) {
        taskTypeSettingModalElement.removeEventListener('click', this.stopClickEvent, true)
        taskTypeSettingModalElement.addEventListener('click', this.stopClickEvent, true)
      } else {
        taskTypeSettingModalElement.removeEventListener('click', this.stopClickEvent, true)
      }
    },
    /**
     * クリックイベントを避ける
     * @param {Event} event それはイベントです
     */
    stopClickEvent(event) {
      event.stopPropagation()
      event.preventDefault()
    },
    /**
     * 作業指示なしのスキャン項目を構築します。
     */
    buildScanItemForNoWorkInstruction() {
      this.tabsMenu = [...[this.originalTabsMenu[NORMAL_SORT]]]
      this.tabActive = this.tabsMenu[0]['value']
      this.handleDisplayTitleTableScanItem(this.tabActive)
    },
    /**
     * HTML入力要素での特定の文字（「/」または「\」）の入力を禁止します。
     * @param {string} value 入力値。チェック対象となる文字（「/」または「\」）を含む場合、エラーが表示されます
     * @param {string} id HTML入力要素のID
     */
    preventInvalidInputValue(value, id) {
      const input = document.getElementById(id)
      const invalidChar = value.match(AppConstants.TASK_TYPE_NAME_PROHIBITED_CHAR_CODES_REGEX)
      if (input && invalidChar) {
        const warningMessage = invalidChar[0] === '/' || invalidChar[0] === '／'
          ? '/（スラッシュ）は使用不可です。'
          : '＼（バックスラッシュ）は使用不可です。'
        input.setCustomValidity(warningMessage)
        input.reportValidity()
        setTimeout(() => {
          this.taskTypeSettingForm['taskTypeName'] = value.replaceAll(AppConstants.TASK_TYPE_NAME_PROHIBITED_CHAR_CODES_REGEX, '')
        }, 10)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin styleTitleBody() {
  &__title {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    h4 {
      font-weight: bold;
      @include responsive-fs(20);
      margin: 0;
    }
  }
}
@mixin styleBlock($blockName: '') {
  display: flex;
  flex-direction: column;
  padding: 0 0 0 16px;
}
@mixin styleLine(
  $marginTop: 40px,
  $marginBottom: 40px,
  $marginLeftRight: 16px
) {
  background: #d6d6d6;
  width: calc(100% - 16px);
  height: 1px;
  margin: $marginTop $marginLeftRight $marginBottom;
}

.modal-type-setting {
  position: relative;
  .buttonClose {
    justify-content: flex-end;
    color: #666563;
    background-color: #ffffff;
    .btn-close {
      padding-bottom: 0px;
      text-decoration: none;
    }
  }
  .modal-wrap-colum {
    max-height: 800px !important;
    min-height: 500px !important;
    // 130pxはモーダルの上部と下部のスペースです。
    height: calc(100vh - 130px) !important;
    @include media-breakpoint-default() {
      flex-direction: column;
    }
  }
  .modal-left {
    min-width: 320px;
    flex-shrink: 0;
    height: 100%;
    background-color: #f8f8f8;
    @include media-breakpoint-default() {
      height: auto;
      width: 100%;
    }
    &__top {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      height: 40%;
      background: white;
      padding: 0 0 16px 24px;
      @include media-breakpoint-default() {
        height: auto;
        background: none;
        flex-direction: row;
        align-items: center;
        padding: 16px;
      }
      img {
        height: 94%;
        width: 100%;
        @include media-breakpoint-default() {
          display: none;
        }
      }
      .titleHeader {
        @include media-breakpoint-default() {
          margin-bottom: 0;
        }
      }
    }
    &__bot {
      background-color: #f8f8f8;
      height: 45%;
      @include media-breakpoint-default() {
        height: auto;
      }
    }
    &__step {
      height: 100%;
      position: relative;
      @include media-breakpoint-default() {
        display: flex;
        height: auto;
      }
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 32px;
        font-weight: bold;
        height: calc(100% / 3);
        @include media-breakpoint-default() {
          flex-direction: column;
          padding-left: 0;
          height: auto;
          width: calc(100% / 3);
        }
        &.completed {
          background-color: #f8f8f8;
          .check {
            background-color: #1fa790;
            color: #ffffff;
          }
        }
        &.selected {
          background-color: #ffffff;
        }
        .text {
          @include media-breakpoint-default() {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            min-height: 40px;
            width: 100%;
            padding: 8px;
          }
        }
        .num {
          margin-right: 16px;
          @include media-breakpoint-default() {
            margin-right: 4px;
          }
        }
        .check {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          aspect-ratio: 1 / 1;
          color: #d6d6d6;
          @include media-breakpoint-default() {
            width: 100%;
            height: 50px;
          }
          i {
            display: flex;
            align-items: center;
            justify-content: center;
            @include responsive-fs(40);
            width: 40px;
            height: 40px;
            @include media-breakpoint-default() {
              @include responsive-fs(20);
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
    &__btn-save {
      padding: 24px;
      @include media-breakpoint-default() {
        padding: 16px;
        display: flex;
      }
      .btn-close {
        @include media-breakpoint-default() {
          color: #ffffff;
          display: flex !important;
          justify-content: center;
          align-items: center !important;
        }
      }
      button {
        width: 100%;
        height: 45px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include responsive-fs(18);
        @include media-breakpoint-default() {
          margin-right: 8px;
        }
        &:last-child {
          @include media-breakpoint-default() {
            margin-right: 0;
          }
        }
        &:disabled {
          background: #afafae;
          color: #ffffff;
          opacity: 1;
          border: none;
        }
        @include media-breakpoint-default() {
          height: 40px;
        }
      }
    }
  }
  .modal-right {
    max-height: 741px;
    overflow: auto;
    padding: 0 16px 24px 48px;
    flex: 1;
    overflow-x: hidden;
    @include media-breakpoint-default() {
      padding: 16px;
      max-height: 100%;
    }
    &__title {
      display:  flex;
      align-items: center;
      margin-bottom: 24px;
      h4 {
        margin-bottom: 0;
        @include responsive-fs(20);
        font-weight: bold;
        @include media-breakpoint-default() {
          @include responsive-fs(14);
        }
      }
    }
    .form-group {
      margin-bottom: 24px;
      @include media-breakpoint-default() {
        padding-left: 0;
        margin-bottom: 16px;
      }
      &__label {
        display: flex;
        align-items: center;
        font-weight: bold;
        margin-bottom: 4px;
      }
      &__control {
        input {
          border: 1px solid #8A8988;
        }
      }
      &__select-list {
        margin-bottom: 8px;
        .sortingSettingSelected {
          width: 238px;
        }
        .no {
          margin-right: 8px;
        }
      }
    }
    .group-control {
      margin-top: 48px;
      @include media-breakpoint-default() {
        margin-top: 24px;
      }
      button {
        width: 96px;
        height: 45px;
        background-color: #4E66A6;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        @include responsive-fs(18);
        font-weight: bold;
        &:nth-child(2) {
          margin-left: 4px;
        }
        @include media-breakpoint-default() {
          height: 40px;
        }
        &.btn-prev {
          color: #4E66A6;
          font-weight: normal;
          border: none;
          background: none;
        }
      }
    }
    .radio-custom {
      margin-bottom: 48px;
      @include media-breakpoint-default() {
        margin-bottom: 24px;
      }
      &--xl {
        .radio-custom__img {
          width: 160px;
          @include media-breakpoint-default() {
            width: 80px;
            img {
              max-width: 100%;
            }
          }
        }
      }
      &--row {
        display: flex;
        .radio-custom {
          &__item {
            flex-direction: column;
            cursor: pointer;
            width: calc((100% - 16px ) / 3);
            margin-right: 8px;
            &:nth-child(3n+3) {
              margin-right: 0;
            }
            @include media-breakpoint-default() {
              margin-right: 4px;
              width: calc((100% - 8px ) / 3);
              &:nth-child(3n+3) {
                margin-right: 0;
              }
            }
          }
          &__checkmark {
            margin-top: 7.3px;
            margin-bottom: 7.3px;
          }
          &__overlay {
            width: 100%;
            height: 28px;
          }
        }
      }
      &__item {
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        border: 1px solid #D6D6D6;
        width: 100%;
        @include media-breakpoint-default() {
          margin-right: 4px;
          width: 468px;
        }
        &.disabled {
          color: #8d8d8d !important;
          pointer-events: none;
          cursor: default !important;
          opacity: 0.8;
        }

        &:hover {
          .radio-custom__overlay {
            display: block;
          }
        }

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;

          &:checked~.radio-custom__checkmark {
            border-color: #4E66A6;
          }

          &:checked~.radio-custom__checkmark:after {
            display: block;
          }

          &:checked~.radio-custom__overlay {
            display: block;
          }

          &:disabled~.radio-custom__checkmark::after {
            background: #c3c3c3;
          }

          &:disabled~.radio-custom__checkmark {
            border-color: #c3c3c3;
          }
        }
      }

      &__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 100%;
        background: rgba(78, 102, 166, 0.08);
        display: none;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        @include media-breakpoint-default() {
          width: 30px;
        }
      }

      &__checkmark {
        position: relative;
        width: 14px;
        height: 14px;
        background: #ffffff;
        border-radius: 50%;
        margin-left: 13px;
        margin-right: 13px;
        border: 1px solid #AFAFAE;
        flex-shrink: 0;
        @include media-breakpoint-default() {
          margin-left: 8px;
          margin-right: 8px;
        }

        &:after {
          content: "";
          position: absolute;
          display: none;
          top: 50%;
          left: 50%;
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #4E66A6;
          transform: translate(-50%, -50%) rotate(45deg);
        }
      }

      &__img {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 120px;
        @include media-breakpoint-default() {
          width: 60px;
          img {
            max-width: 100%;
          }
        }
      }

      &__body {
        padding: 16px 10px 16px 10px;
      }

      &__title {
        font-weight: bold;
        margin-bottom: 8px;
      }

      &__content {
        width: 100%;
        @include responsive-fs(12);
      }

      &__note {
        background: #F8F8F8;
        border: 1px solid #AFAFAE;
        border-radius: 2px;
        margin-top: 8px;
        padding: 4px 2px;
        @include media-breakpoint-default() {
         padding-left: 10px;
        }
      }
    }
    .checkbox-custom {
      display: flex;
      margin-bottom: 48px;
      &--switch {
        margin-top: -24px;
        margin-right: -24px;
        margin-left: -24px;
        .checkbox-custom {
          &__item {
            height: 268px;
            border-top: none;
            border-left: none;
            margin-right: 0;
            width: calc(100% / 3);
            background-color: #F8F8F8;
            &:nth-child(3n+3) {
              border-right: none;
            }
            &.active {
              background: #ffffff;
            }
          }
          &__title {
            margin: 16px 0 4px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            &--bot {
              margin-top: 0;
              margin-bottom: 8px;
              padding-left: 7px;
            }
            i {
              @include responsive-fs(14);
              width: 14px;
              color: #AFAFAE;
            }
          }
          &_body {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          &__content {
            height: 120px;
          }
        }
      }
      &--col-2 {
        .checkbox-custom {
          &__item {
            width: 50%;
            height: auto;
          }
          &__body {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
      }
      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        cursor: pointer;
        width: calc((100% - 16px ) / 3);
        height: 184px;
        border: 1px solid #D6D6D6;
        margin-bottom: 0;
        margin-right: 8px;

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          .checkbox-custom__overlay {
            display: block;
          }
        }

        input {
          position: absolute;
          opacity: 0;
          cursor: pointer;

          &:checked~.checkbox-custom__checkmark {
            border-color: #4E66A6;
            background: #4E66A6;
          }

          &:checked~.checkbox-custom__checkmark:after {
            display: block;
          }

          &:checked~.checkbox-custom__overlay {
            display: block;
          }
        }
      }

      &__overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 36px;
        background: rgba(78, 102, 166, 0.08);
        display: none;

        &.disabled {
          display: none !important;
        }
      }

      &__checkmark {
        position: relative;
        width: 18px;
        height: 18px;
        background: #ffffff;
        border: 2px solid #AFAFAE;
        flex-shrink: 0;
        border-radius: 2px;
        margin-top: 9px;
        margin-bottom: 9px;

        &:after {
          content: "";
          position: absolute;
          display: none;
          top: -1px;
          left: 4px;
          width: 6px;
          height: 12px;
          border: solid #ffffff;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        &.disabled {
          background: #afafae !important;
          border-color: #afafae !important;
        }
      }

      &__body {
        height: 100%;
      }

      &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-weight: bold;
        flex-shrink: 0;
        height: 26px;
      }

      &__content {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100% - 26px);
      }

      .disabled-work-type {
        background: #d6d6d6;
        cursor: default !important;
        opacity: 0.8;
      }
    }

    .box-rule {
      padding: 16px;
      border: 1px solid #D6D6D6;
      &__left {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 160px;
        @include media-breakpoint-default() {
          width: 80px;
          padding-right: 16px;
        }
      }
      &__add{
        display: flex;
        align-items: center;
        width: 70px;
        height: 27px;
        @include responsive-fs(12);
        color: #4E66A6;
        margin-top: 8px;
        padding-left: 18px;
        background: none;
        border: none;
        white-space: nowrap;
        span {
          @include responsive-fs(14);
        }
      }
      &__remove{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px 6px;
        button {
          display: flex;
          align-items: center;
          height: 27px;
          width: 16px;
          @include responsive-fs(12);
          padding: 0;
          color: #B41B3E;
          background: none;
          border: none;
        }
        i {
          @include responsive-fs(14);
          width: 14px;
          height: 14px;
          position: relative;
          right: 1px;
        }
      }
    }
  }
}

.scan-code {
  border: 1px solid #D6D6D6;
  padding: 16px;
  &__group-len {
    @include media-breakpoint-default() {
      flex-direction: column;
    }
  }
  &__position {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 115px;
    padding-inline: 8px;
    background: #F8F8F8;
    @include media-breakpoint-default() {
      margin-top: 8px;
      width: 100%;
    }
    .number {
      @include responsive-fs(20);
      font-weight: bold;
      span {
        color: #B41B3E;
      }
    }
    .des {
      @include responsive-fs(12);
      color: #666563;
    }
    &--sm {
      width: fit-content;
      padding-inline: 8px;
      @include media-breakpoint-default() {
        margin-left: 8px;
        flex-shrink: 0;
      }
    }
  }
  &__input-position {
    input {
      width: 129px!important;
      @include media-breakpoint-default() {
        width: 75px !important;
      }
    }
    .label {
      @include responsive-fs(18);
      color: #666563;
      margin-left: 8px;
      flex-shrink: 0;
      white-space: nowrap;
    }
  }
  &__input-last-digit {
    width: 219px;
    @include media-breakpoint-default() {
      width: 100%;
    }
  }
  &__title {
    @include responsive-fs(12, true);
  }
  &__number-fill {
    @include responsive-fs(32);
    font-weight: bold;
    margin-top: 16px;
    @include media-breakpoint-default() {
      text-align: center;
    }
    span {
      color: #B41B3E;
    }
  }
}

/deep/ .modal-content {
  border: none;
  border-radius: 0;
  @include media-breakpoint-medium() {
    width: 500px !important;
  }
}
/deep/ .modal-type-setting {
  .modal-dialog {
    min-width: 900px;
    width: 60vw;
    margin: auto;
    @include responsive-fs(16);
    @include media-breakpoint-default() {
      min-width: 500px;
      width: 500px;
    }
    @include media-breakpoint-medium() {
      padding: 16px;
    }
  }
}

/deep/ .card {
  border: 2px solid #AFAFAE !important;
  border-radius: 4px !important;
  height: auto !important;
  min-height: 250px !important;
}
/deep/ .card-body {
  padding: 44px 40px !important;
  background: #F8F8F8 !important;
  justify-content: center !important;
}
/deep/ .card-title {
  @include responsive-fs(14, true);
  margin-bottom: 8px;
  font-weight: bold;
}
/deep/ .card-header {
  background: #ffff !important;
  padding: 8px 8px !important;
  padding-left: 0 !important;
}
/deep/ .card-footer {
  background: #F8F8F8 !important;
  padding: 8px !important;
}
/deep/ .modal-header {
  padding: 5px 0 !important;
  padding-right: 10px !important;
  border-bottom: none !important;
  justify-content: flex-end;
}
/deep/ .modal-body {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.titleHeader {
  margin-top: 5px;
  font-weight: bold;
  @include responsive-fs(24);
  text-align: center;
}
.button-modal-header {
  font-style: normal;
  font-weight: normal;
  line-height: 160%;
  .buttonClose {
    color: #666563;
    &:hover {
      text-decoration: none;
    }
  }
}
div#scrollspy {
  position: relative;
  max-height: calc(100vh - 240px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 16px;
}

.lineBetweenTaskAdWork,
.lineBetweenWorkAdScan {
  @include styleLine();
}
.lineBetweenScanAdBtn {
  @include styleLine($marginTop: 32px, $marginBottom: 24px);
}
// style html label for task type, working mode
.htmlLabel {
  font-style: normal;
  font-weight: bold;
  color: #666563;
}
// TASK TYPE BLOCK
.taskType {
  @include styleBlock('taskType');
  @include styleTitleBody();
  &__form {
    padding-left: 40px;
    &__taskTypeField,
    &__taskTypeNameField,
    &__isEnableField {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }
    &__isEnableField {
      margin-bottom: 0;
    }
  }
}
// WORKING MODE BLOCK
.workingMode {
  @include styleBlock('workingMode');
  @include styleTitleBody();
  &__form {
    padding-left: 40px;
    &__workingModeFields {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }
  }
}
.edit_icon_detail {
  color: #4E66A6;
  @include responsive-fs(12);
  visibility: hidden;
  margin-left: 6px;
  &:hover {
    cursor: pointer;
  }
}
.icon_drag {
  @include responsive-fs(25);
  color: #8a8988;
  visibility: hidden;
  &:hover {
    cursor: pointer;
  }
}
/deep/ .editableLabel-input {
  max-height: 27px !important;
  height: 27px !important;
}

// SCAN ITEMS BLOCK
.scanItems {
  @include styleTitleBody();
  border: 1px solid #D6D6D6;
  max-width: 100%;
  &__form {
    &__tabs {
      display: flex;
      align-items: center;
      padding: 16px 8px 8px 8px;
      .itemMenu {
        font-style: normal;
        font-weight: 400;
        @include responsive-fs(12);
        text-align: center;
        color: #252422 !important;
        margin: 0 3px !important;
        padding: 4px 16px;
        &:hover {
          background: rgba(78, 102, 166, 0.08) !important;
          border-radius: 40px !important;
          cursor: pointer;
        }
      }
      .tabsMenu {
        padding-left: 15px;
      }
      .isActiveTab {
        background: rgba(78, 102, 166, 0.08) !important;
        border-radius: 40px !important;
        font-weight: bold;
      }
    }
    .underLineTabs {
      background: #d6d6d6;
      height: 1px;
      margin: 4px 0 24px 0;
      width: 100%;
    }
    &__blockList {
      .description {
        display: flex;
        font-weight: normal;
        color: #666563;
        margin-bottom: 24px;
        padding-left: 16px;
      }
      &__tableAdImage {
        width: 100%;
        @media (max-width: 1366px) {
          flex-direction: column;
        }
        @media (min-width: 1366px) {
          table {
            height: 50% !important;
          }
          table tr{
            padding: 20px 0px !important;
          }
        }
        .wrap-table {
          padding: 0 16px;
        }
        table {
          border-spacing: 0;
          th {
            white-space: nowrap;
            &:nth-child(2) {
              text-align: center;
            }
            @include responsive-fs(12);
          }
          td {
            font-weight: bold;
            color: #666563;
            border-bottom: 1px solid #dee2e6;
            vertical-align: middle;
            min-height: 54px;
            &:nth-child(2) {
              text-align: center;
              font-style: normal;
              font-weight: normal;
              @include responsive-fs(18);
              color: #252422;
            }
            &:nth-child(3):hover {
              cursor: pointer;
            }
          }
          tbody tr:hover {
            background: rgba(78, 102, 166, 0.08);
            cursor: pointer;
          }
          thead tr th,
          tbody tr td {
            border-top: none;
          }
        }
        .blockPreview {
          &__title {
            display: block;
            font-weight: normal;
            @include responsive-fs(14);
            color: #666563;
            text-align: center;
          }
          &__wrap-preview {
            background: #F8F8F8;
            padding: 24px 16px 24px 124px;
            position: relative;
            @include media-breakpoint-default() {
              padding: 8px;
            }
          }
          &__image {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 38px;
            @include media-breakpoint-default() {
              display: none;
            }
          }
          &__cardPreviewScanItems {
            border: 2px solid #252422!important;
            position: relative;
            &:after {
              content: "";
              display: block;
              width: 15px;
              height: 15px;
              border-bottom: 2px solid #252422;
              border-left: 2px solid #252422;
              position: absolute;
              top: 50%;
              left: -9px;
              transform: translateY(-50%) rotate(45deg);
              background: #F8F8F8;
              @include media-breakpoint-default() {
                display: none;
              }
            }
            .fieldLabel {
              font-weight: bold;
              @include responsive-fs(14);
              margin: 0;
              padding-right: 10px !important;
            }
            .inputFieldWrap {
              padding: 0;
              position: relative;
              i {
                width: 18px;
                @include responsive-fs(20);
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 15px;
                color: #AFAFAE;
              }
              .inputField {
                padding-left: 40px;
                background: #FFFFFF;
                border: 2px solid #AFAFAE;
                border-radius: 4px;
                @include responsive-fs(14);
                &::placeholder {
                  color: #AFAFAE;
                }
              }
            }
          }
          .layoutHeader {
            &__left {
              display: flex;
              align-items: center;
              .icon {
                @include responsive-fs(24);
                color: #8A8988;
              }
              .circles {
                background: #D6D6D6;
                border-radius: 50%;
                width: 24px;
                height: 24px;
              }
              .line {
                display: flex;
                flex-direction: column;
                margin-left: 4px;
                &__on {
                  background: rgba(37, 36, 34, 0.04);
                  width: 92px;
                  height: 4px;
                  margin-bottom: 4px;
                }
                &__down {
                  background: rgba(37, 36, 34, 0.04);
                  width: 92px;
                  height: 12px;
                }
              }
            }
            &__right {
              display: flex;
              align-items: center;
              .lineStart, .lineCenter, .lineEnd {
                background: rgba(37, 36, 34, 0.04);
                width: 26px;
                height: 6px;
                margin-right: 8px;
              }
              .blockColor {
                background: #4E66A6;
                border-radius: 4px;
                width: 32px;
                height: 16px;
              }
            }
          }
          .layoutFooter {
            &__left {
              display: flex;
              align-items: center;
              .blockWhiteColor {
                width: 60px;
                height: 24px;
                background: #FFFFFF;
                border-radius: 4px;
                margin-right: 4px;
              }
              .line {
                &__on, &__down {
                  width: 92px;
                  height: 4px;
                  background: rgba(37, 36, 34, 0.04);
                  margin-bottom: 4px;
                }
              }
            }
            &__right {
              .blockBlueColor {
                width: 60px;
                height: 24px;
                background: #4E66A6;
                border-radius: 4px;
              }
            }
          }
        }
      }
    }
  }
}

.saveBtn {
  height: 40px;
  width: 110px;
  border-radius: 4px;
}

/deep/ .alert-message {
  @include media-breakpoint-default() {
    top: 0px;
    width: 100%;
    .alert-danger {
      min-width: 100% !important;
    }
  }
}
.editable-input {
   word-break: break-word;
}

/deep/ .editable-input {
  position: relative;
  .editableLabel-input {
    display: block;
    position: absolute;
    top: -19px;
    left: 0;
    padding: 7px 8px 7px 16px;
    height: 38px!important;
    max-height: 38px!important;
    width: 332px;
    background: #ffffff;
    border: 1px solid #8A8988;
    border-radius: 4px;
    z-index: 3;
    @include media-breakpoint-default() {
      width: calc(180px);
    }
  }
}

.switch-btn-wrapper {
  position: relative;
  height: 60px;
  @include media-breakpoint-default() {
    height: 46px;
  }
  &__enable-task-type {
    min-height: 60px;
    bottom: 90px;
    @include media-breakpoint-default() {
      min-height: 46px;
      bottom: 0;
    }
  }
}

.switch-wrapper {
  position: relative;
  width: 120px;
  height: 60px;
  .switch-radio-label {
    box-sizing: border-box;
    position: absolute;
    display: flex;
    align-items: center;
    @include responsive-fs(24);
    width: 100%;
    height: 60px;
    padding: 8px;
    color: #ffffff;
    font-weight: bold;
    cursor: pointer;
    top: 0;
    margin-bottom: 0;
    transition: all, 0.4s, ease-out;
    @include media-breakpoint-default() {
      height: 40px;
      padding-bottom: 11px;
    }

    &.active {
      opacity: 0;
      left: 0;
    }

    &.inactive {
      z-index: 2;
      right: 0;
    }
  }

  .switch-radio-label.left {
    justify-content: flex-end;
  }

  .switch-radio-label.right {
    justify-content: flex-start;
  }

  /* checked logic selector */
  .switch-radio.right:checked+.slider {
    background-color: #AFAFAE;
    &:after {
      background-color: #D6D6D6;
      border: 2px solid rgba(78, 102, 166, 0.24);
    }
  }

  /* checked logic selector */
  .switch-radio.right:checked+.slider:after {
    transform: translateX(0);
  }

  /* checked logic selector */
  .switch-radio.left:checked+.switch-radio-label.right:after {
    content: "";
    position: absolute;
    top: -10px;
    right: 0;
    bottom: -10px;
    left: -36px;
    z-index: 2;
  }

  &--like-checkbox {
    $checkbox-width: 95px;
    $checkbox-height: 36px;
    width: $checkbox-width;
    height: 36px;
    .switch-radio-label {
      width: $checkbox-width;
      height: $checkbox-height;
    }
    .switch {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: $checkbox-width;
      height: $checkbox-height;
      .switch-radio {
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        border: 0;
        position: absolute;
        clip: rect(0 0 0 0);
        overflow: hidden;

        &:disabled +.slider .switch-radio-label {
        cursor: default;
        }

        &:checked+.slider .switch-radio-label.inactive {
          opacity: 0;
        }

        &:checked+.slider .switch-radio-label.active {
          opacity: 1;
          z-index: 20;
        }
      }
      .slider {
        content: "";
        position: absolute;
        cursor: pointer;
        width: $checkbox-width;
        height: $checkbox-height;
        border-radius: 4px;
        background: rgba(78, 102, 166, 0.08);
        border: none;
        &:after {
          content: "";
          position: absolute;
          width: 18px;
          height: 18px;
          top: 9px;
          left: 15px;
          background-image: none;
          border: none;
          border-radius: 4px;
          background: #4E66A6;
          transform: translateX(0);
        }
        &:before {
          content: '';
          display: block;
          width: 6px;
          height: 12px;
          position: absolute;
          top: 10px;
          left: 21px;
          z-index: 1;
          border-right: 2px solid #ffffff;
          border-bottom: 2px solid #ffffff;
          transform: rotate(45deg);
        }
      }
      .slider.disabled {
        background-color: rgba(37, 36, 34, 0.08);
        &:after {
          background: #252422;
        }
      }
    }
    .switch-radio.right:checked+.slider {
      background-color: transparent;
      &:after {
        border: 2px solid #AFAFAE;
        background: #FFFFFF;
      }
    }
    .switch-radio.right:checked+.slider:after {
      transform: translateX(0);
    }
    .label-text {
      color: #252422;
      @include responsive-fs(18);
      font-weight: normal;
      margin-right: 8px;
    }
  }
}

.switch-checkbox {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 60px;
  margin-bottom: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked+.slider {
      background-color: #4E66A6;

      &:before {
        transform: translateX(0);
      }

      &.round {
        &:after {
          content: "有効";
          top: 11px;
          left: auto;
          right: 8px;
        }
      }
    }

    &:focus+.slider {
      box-shadow: 0 0 1px #2196F3;
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #AFAFAE;
    -webkit-transition: .4s;
    transition: .4s;

    &:before {
      position: absolute;
      content: "";
      height: 52px;
      width: 52px;
      border: 2px solid rgba(78, 102, 166, 0.24);
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: .4s;
      transform: translateX(61px);
      box-sizing: border-box;
    }

    &.round {
      border-radius: 34px;
      border: 1px solid #AFAFAE;

      &:before {
        border-radius: 50%;
        background-image: url(../../assets/images/icon_handle.svg);
        background-repeat: no-repeat;
        background-position: center;
      }

      &:after {
        content: "無効";
        @include responsive-fs(24);
        font-weight: bold;
        color: #FFFFFF;
        position: absolute;
        top: 11px;
        left: 8px;
      }
    }
  }
}

.wrap-box-border {
  margin-bottom: 24px;
}

.box-input {
  border: 1px solid #AFAFAE;
  padding: 16px;
  &__title {
    display: flex;
    align-items: center;
    h5 {
      @include responsive-fs(16);
      font-weight: bold;
      color: #666563;
      margin-bottom: 0;
    }
  }
  &__content {
    @include responsive-fs(18);
    color: #666563;
    margin-bottom: 0;
  }
  &__group {
    @include responsive-fs(18);
    color: #666563;
    input {
      width: 80px;
      margin-right: 8px;
    }
    #fullChuteLevel {
      width: 80px;
      height: 43px;
      margin-right: 8px;
    }
  }
}
/deep/ #modal-confirm___BV_modal_content_ {
  border: 1px solid rgba(0,0,0,.2) !important;
  border-radius: 0.3rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/task-type-setting/TaskTypeSettingModal.vue